import TradingViewWidget from "../../components/tradingView";
const articles = {
  en: [
    {
      id: 19,
      title: "MPXL Turns Performance Around, Net Profit Grows to Rp4.11 Billion",
      url: "mpxl-berhasil-membalikkan-kinerja-laba-bersih-tumbuh-menjadi-rp411-miliar",
      image: "/images/artikel/307815069p.jpg",
      date: "Monday, August 10, 2026 / 11:59 WIB",
      preview:
        "PT MPX Logistics International Tbk (MPXL) posted positive first-half 2026 results, with revenue growth and a return to net profit.",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID - Jakarta, July 2026</strong> PT MPX Logistics
            International Tbk ("MPXL" or the "Company"), an integrated
            logistics and transportation service provider, successfully posted
            positive performance in the first half of 2026. The Company
            recorded revenue growth of 28.8% compared with the same period of
            the previous year, while also successfully turning a loss position
            into net profit.
          </p>
          <p>
            In the first half of 2026, the Company posted revenue of Rp73.12
            billion, up from Rp56.77 billion in the first half of 2025. This
            growth was mainly driven by increased activity in the expedition
            services segment, which recorded revenue of Rp50.98 billion, up
            around 54.5% from the same period of the previous year.
          </p>
          <p>
            Alongside higher revenue, the Company also succeeded in improving
            operational efficiency. Gross profit rose significantly by 96.5% to
            Rp15.09 billion, compared with Rp7.68 billion in the first half of
            2025. Gross Profit Margin also improved from 13.5% to 20.6%,
            reflecting increasingly effective control over the cost of revenue.
          </p>
          <p>
            More efficient operating performance was also reflected in EBITDA,
            which increased 101.3% to Rp16.44 billion, with EBITDA Margin rising
            from 14.3% to 22.5%. This indicates that the quality of the
            Company's earnings is improving and is derived from its core
            business activities.
          </p>
          <p>
            The Company also maintained discipline in cost management. General
            and administrative expenses remained relatively under control, while
            finance costs declined to Rp4.17 billion, in line with efforts to
            optimize the financing structure and manage liabilities.
          </p>
          <p>
            Thanks to revenue growth and improved efficiency, MPXL succeeded in
            posting profit before tax of Rp4.69 billion, reversing from a
            pre-tax loss of Rp3.00 billion in the first half of 2025. After
            accounting for income tax, the Company recorded net profit of
            Rp4.11 billion, improving by 217.2% from a net loss position of
            Rp3.50 billion in the same period of the previous year.
          </p>
          <p>
            In addition to improved profitability, the Company also continued
            to strengthen its financial fundamentals. Total liabilities declined
            compared with the end of 2025, while equity increased as a positive
            effect of the profit generated during the first half of 2026. A
            healthier capital structure is expected to support sustainable
            business development.
          </p>
          <p>
            The Board of Directors stated that the first-half 2026 achievement
            was the result of the Company's focus on increasing fleet
            utilization, strengthening logistics services, improving operating
            cost efficiency, and maintaining disciplined financial management.
          </p>
          <p>
            Going forward, MPXL will continue its growth strategy through
            strengthening its national logistics business, increasing the
            contribution of expedition services, developing its heavy equipment
            rental business, and expanding its business portfolio through coal
            trading and sea transportation services using barges. These measures
            are expected to create more diversified revenue streams while
            strengthening the Company's position as an integrated logistics
            service provider in Indonesia.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Source:{" "}
              <a
                href="https://pressrelease.kontan.co.id/news/mpxl-berhasil-membalikkan-kinerja-laba-bersih-tumbuh-menjadi-rp411-miliar"
                target="_blank"
                rel="noreferrer"
              >
                https://pressrelease.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 18,
      title:"Diversifying its business, MPX Logistics (MPXL) establishes a new subsidiary",
      url:"diversifikasi-bisnis-mpx-logistics-mpxl-dirikan-anak-usaha-baru",
      image: "/images/artikel/1374075960p.jpg",
      date: "Thursday, January 22, 2026 / 14:43 WIB",
      preview:"Diversifying its business, MPX Logistics (MPXL) establishes a new subsidiary",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID - JAKARTA.</strong> PT MPX Logistics International
            Tbk (MPXL) announced the establishment of a new business entity, PT
            Tambang Raya Sejahtera.
          </p>

          <p>
            Director and Corporate Secretary James S. Chandra said the subsidiary
            will operate in large-scale trading, covering solid, liquid, and gas
            fuels and related products (KBLI 46610), metal and metal-ore trading
            (KBLI 46620), and non-metal mineral trading (KBLI 46641).
          </p>
          <p>
            The capital structure and shareholders of PT Tambang Raya Sejahtera
            comprise authorized capital of Rp 10 billion and issued and paid-up
            capital of Rp 5 billion. Of that, MPXL holds Rp 4.97 billion (99.5%),
            while James S. Chandra holds Rp 25 million (0.5%).
          </p>
          <p>
            “The establishment of this subsidiary supports the company's
            operations and develops MPXL's business diversification, which is
            expected to generate revenue and expand the MPXL group,” James wrote
            in an information disclosure on Thursday (1/22/2026).
          </p>
          <p>
            In earlier reporting, MPXL was optimistic it could deliver at least
            50% revenue growth and improve profits in 2026.
          </p>
          <p>
            President Director Wijaya Candera said MPXL will optimize its
            business diversification strategy, including expanding commodity
            transportation.
          </p>
          <p>
            Beyond transporting construction and infrastructure materials, MPXL
            will also handle crude palm oil (CPO).
          </p>
          <p>
            MPXL is also expanding its trading segment. In addition to bulk
            cement and fly ash, the company plans to enter split-stone sales and
            coal trading.
          </p>
          <p>
            Wijaya is confident that CPO hauling and coal trading will lift
            MPXL's revenue next year.
          </p>
          <p>
            “Our target for 2026 is at least 50% revenue growth over 2025. For
            profits, we aim to perform better than 2025. The strategy is business
            diversification, from cement trucking to CPO and coal trading in the
            domestic market,” Wijaya told Kontan.co.id on Friday (12/26/2025).
          </p>
          <p>
            Looking ahead to 2026, MPXL's focus at the end of 2025 is to improve
            its business and financial performance. As of the third quarter of
            2025, MPXL's performance was under pressure: revenue declined and the
            company posted a loss.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Source:{" "}
              <a
                href="https://investasi.kontan.co.id/news/diversifikasi-bisnis-mpx-logistics-mpxl-dirikan-anak-usaha-baru"
                target="_blank"
                rel="noreferrer"
              >
                https://investasi.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 17,
      title: "MPX Logistics (MPXL) Establishes New Business Capital in the Maritime Transportation Sector",
      url: "mpx-logistics-mpxl-dirikan-modal-usaha-baru-dibidang-angkutan-laut",
      image:"/images/artikel/1374075960p.jpg",
      date: "Wednesday, February 5, 2025 / 18:35 WIB",
      preview: "MPX Logistics (MPXL) Establishes New Business Capital in the Maritime Transportation Sector",
      desc:(

        <>

        <p>
          <strong>KONTAN.CO.ID - JAKARTA.</strong> Transportation and logistics issuer, PT MPX Logistics International Tbk (MPXL), has established a subsidiary named PT MPX Maritim Nusantara.
          </p>

          <p>
          MPX Logistics International's Corporate Secretary, James S. Chandra, explained that MPX Maritim Nusantara will focus on domestic sea transportation operations.
          </p>

          <p>
          The company, based in North Jakarta, specializes in sea transportation for general and special cargo. MPX Maritim Nusantara also functions as a holding company.
          </p>

          <p>
          MPX Maritim Nusantara has paid-up capital of 100 shares, valued at Rp 10 billion. MPXL owns 49,999 shares of MPX Maritim Nusantara.
          </p>

          <p>
          Meanwhile, the remaining one share is owned by Wijaya Candera, with a nominal ownership value of Rp 100,000 in MPX Maritim Nusantara.
          </p>

          <p>
          “The establishment of MPX Maritim Nusantara will bring positive impacts and contributions to MPXL in the future,” James stated in a public disclosure on Wednesday (5/2).
          </p>

          <p>
          James mentioned that as a subsidiary, MPX Maritim Nusantara will expand its business network as part of MPXL's strategic business development plan.
          </p>

          <p>
          As of September 2024, MPXL recorded revenue of Rp 147.97 billion. This marks a 51.34% year-on-year (YoY) increase from Rp 97.77 billion in September 2023.
          </p>

          <p>
          On the bottom line, profit attributable to MPXL's parent entity owners reached Rp 12.11 billion by the third quarter of 2024, representing a 57.79% YoY increase from Rp 7.67 billion.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="hthttps://investasi.kontan.co.id/news/mpx-logistics-mpxl-dirikan-modal-usaha-baru-dibidang-angkutan-laut"
                target="_blank"
                rel="noreferrer"
              >
              https://investasi.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      )
    },
    {
      id: 16,
      title: "MPX Logistics International (MPXL) Profit Grows 69.2% in H1 2024",
      url:"laba-mpx-logistics-international-mpxl-tumbuh-692-di-semester-i-2024",
      image:"/images/artikel/307815069p.jpg",
      date:"Friday, July 26, 2024 |  05:13 PM WIB",
      preview:"PT MPX Logistics International Tbk (MPXL) has reported positive performance through the first half of 2024.",
      desc: (
        <>
          <p>
          <strong>KONTAN.CO.ID - JAKARTA.</strong> PT MPX Logistics International Tbk (MPXL) has reported positive performance through the first half of 2024.
          </p>
          <p>
          MPX Logistics International's President Director, Wijaya Candera, stated that the company recorded revenues of IDR 97.06 billion in H1 2024. This represents a 53% increase compared to IDR 63.5 billion in the same period last year.
          </p>
          <p>
          Concurrently, MPXL achieved a net profit of IDR 7.3 billion, reflecting a 69.2% year-on-year growth. In H1 2023, MPXL's net profit was IDR 4.3 billion.
          </p>
          <p>
          Thus, the company recorded an EBITDA growth of 44.6% year-on-year, reaching IDR 16.3 billion. "This growth was driven by increased transport volume and cost efficiency," he said in an official statement on Friday (July 26).
          </p>
          <p>
          Wijaya emphasized that the company will continue to pursue various initiatives to maintain MPXL's positive performance. This includes fleet expansion and renewal, which are crucial for enhancing customer comfort and maintaining high vehicle utilization.
          </p>
          <p>
          Wijaya also mentioned that the company has purchased a 1,250 m² plot of land in Gunung Putri, Bogor, which will be used as a workshop and maintenance facility.
          </p>
          <p>
          "This will make the company more efficient and effective in managing vehicle operations in the future," he explained.
          </p>
          <p>
          Additionally, 20 new truck units arriving this month have mostly been allocated to East Kalimantan. He noted that the company strongly supports the development of the New Capital City (IKN) with the issuance of Presidential Regulation (Perpres) No. 75 of 2024 on the Acceleration of IKN Development.
          </p>
          <p>
          "This serves as a positive signal for us to increase transport volume in the second half of the year," Wijaya added.
          </p>
          <p>
          The capacity for bulk cement and mining materials increased by 35% through the first half of 2024 compared to the same period last year. This makes the company optimistic about achieving its 2024 targets.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://investasi.kontan.co.id/news/laba-mpx-logistics-international-mpxl-tumbuh-692-di-semester-i-2024"
                target="_blank"
                rel="noreferrer"
              >
              https://investasi.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 15,
      title:"Awesome! MPX Logistics Revenue Grows 53% in H1 2024",
      url:"mantap-pendapatan-mpx-logistics-tumbuh-53-di-semester-i-2024",
      image:"/images/artikel/pt-mpx-logistics-international-tbk-mpxl_169.jpeg",
      date:"Friday, July 26, 2024 |  08:30 AM WIB",
      preview:"PT MPX Logistics International Tbk (MPXL) recorded revenues of IDR 97.06 billion in the first half of 2024.",
      desc: (
        <>
          <p>
          <strong>Jakarta, CNBC Indonesia</strong> - PT MPX Logistics International Tbk (MPXL) recorded revenues of IDR 97.06 billion in the first half of 2024. This figure represents a 53% increase compared to IDR 63.50 billion for the same period last year.
          </p>
          <p>
          "This revenue increase has led to a 69.2% rise in net profit attributable to the parent company, reaching IDR 7.35 billion," explained MPXL's President Director, Wijaya Candera, in a statement quoted on Thursday (July 25, 2024).
          </p>
          <p>
          As a result, MPXL recorded a 44.6% year-on-year growth in EBITDA, reaching IDR 16.30 billion compared to the same period last year. This growth was driven by increased transport volume and cost efficiency.
          </p>
          <p>
          To expedite the repair of truck fleets serving customers in West Java and Central Java, MPXL management has purchased a 1,250 m² plot of land in Gunung Putri, Bogor. This land will be used as a workshop and maintenance facility for the company.
          </p>
          <p>
          Wijaya stated that this development will make the company more efficient and effective in managing vehicle operations in the future.
          </p>
          <p>
          Additionally, MPXL has allocated 20 new truck units to East Kalimantan to boost transport volume in the second half of 2024.
          </p>
          <p>
          "We support the development of the New Capital City (IKN) with the issuance of Presidential Regulation (Perpres) No. 75 of 2024 on the Acceleration of IKN Development. This serves as a positive signal for us to increase transport volume in the second half of the year," Wijaya added.
          </p>
          <p>
          Wijaya emphasized that the company will continue to pursue various initiatives to maintain MPXL's positive performance, including expansion and fleet renewal. These efforts are aimed at enhancing customer comfort and maintaining high vehicle utilization rates.
          </p>
          <p>
          He also noted that the capacity for bulk cement and mining materials increased by 35% up to the first half of 2024 compared to the same period last year. This makes the company optimistic about achieving its 2024 targets.
          </p>
          <p>
          "This remarkable achievement is the result of the company's ability to maintain customer loyalty and demand through various strategic measures tailored to customer needs. This positive performance is also supported by careful asset expansion, improved fleet utilization, and a focus on superior service," he concluded.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.cnbcindonesia.com/market/20240725162700-17-557647/mantap-pendapatan-mpx-logistics-tumbuh-53-di-semester-i-2024"
                target="_blank"
                rel="noreferrer"
              >
              https://www.cnbcindonesia.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 14,
      title:"MPXL's Net Profit Soars 123.6 Percent, Driven by Material Transport Services to IKN",
      url:"laba-bersih-mpxl-melonjak-123-6-persen-ditopang-jasa-angkut-material-ke-ikn",
      image:"/images/artikel/6540b313121ae.jpg",
      date:"Wednesday, May 24, 2024 |  10:46 AM WIB",
      preview:"PT MPX Logistics International Tbk (MPXL) recorded a consolidated net profit of Rp 4.08 billion in the first quarter of 2024. This figure grew by 123.6 percent from the consolidated net profit in the first quarter of 2023 amounting to Rp 1.82 billion.",
      desc: (
        <>
          <p>
            <strong>JAKARTA, KOMPAS.com</strong> - PT MPX Logistics International Tbk (MPXL) recorded a consolidated net profit of Rp 4.08 billion in the first quarter of 2024. This figure grew by 123.6 percent from the consolidated net profit in the first quarter of 2023 amounting to Rp 1.82 billion.
          </p>
          <p>
            The increase in net profit is in line with the increasing revenue from material and transport services located in the Nusantara Capital project (IKN).
          </p>
          <p>
            Additionally, the company's revenue is supported by the increased transportation of PLTU (FaBa) coal waste.
          </p>
          <p>
            MPXL President Director Wijaya Candera stated that throughout the first quarter of 2024, MPXL recorded a 60.24 percent year-on-year increase in consolidated net revenue to Rp 45.42 billion in the first quarter of 2024 compared to Rp 28.3 billion in the first quarter of 2023.
          </p>
          <p>
            This growth is driven by a 149.21 percent increase in transport service revenue to Rp 24.8 billion in the first quarter of 2024 compared to Rp 9.9 billion in the first quarter of 2023.
          </p>
          <p>
            Furthermore, revenue from material sales increased by 12.1 percent to Rp 20.6 billion in the first quarter of 2024 compared to Rp 18 billion in the first quarter of 2023.
          </p>
          <p>
            Wijaya added that in the future, MPXL will continue to focus on the Material trading and transport service segments, which are the core business of the company, by continuously developing other logistics transportation such as fly ash, bottom ash, clinker, lime stone, and coal.
          </p>
          <p>
            This year, the company has added 50 units of new tronton truck fleets to meet the increased transportation demand from the company's long-term business contracts.
          </p>
          <p>
            Wijaya explained that these new fleets are projected to increase revenue by Rp 50 billion.
          </p>
          <p>
            "Thus, the company's target of Rp 222 billion in 2024 can be achieved," he said in a written statement on Tuesday (7/5/2024).
          </p>
            <p>
            Not only to increase revenue but also to contribute positively to economic growth in the transportation and logistics sector.
            </p>
            <p>
            Through its subsidiary, MPX Indorental Gemilang, the company has also formed a strategic partnership with a 5-year contract with Power China to provide heavy equipment to be operated in the andesite stone mining area located in Palu, Central Sulawesi.
            </p>
            <p>
            "In addition, the company is also exploring transportation services for andesite stone from the mining area by barge to be sent to the Nusantara Capital," said Wijaya.
            </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://money.kompas.com/read/2024/05/07/161300726/laba-bersih-mpxl-melonjak-123-6-persen-ditopang-jasa-angkut-material-ke-ikn"
                target="_blank"
                rel="noreferrer"
              >
              https://Kompas.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 13,
      title:"MPX Logistics' (MPXL) Profit Skyrockets 123.6%, Here are the Supporting Factors",
      url:"laba-mpx-logistics-mpxl-meroket-1236-ini-penopangnya",
      image:"/images/artikel/1704330991-1600x970.webp",
      date:"Wednesday, April 24, 2024 | 10:46 AM",
      preview:"PT MPX Logistics International Tbk (MPXL) recorded a net profit of Rp 4.08 billion in the first quarter of 2024. This figure grew by 123.6% compared to the same period last year, which was Rp 1.82 billion.",
      desc: (
        <>
            <p>
            <strong>JAKARTA, investor.id</strong> - PT MPX Logistics International Tbk (MPXL) recorded a net profit of Rp 4.08 billion in the first quarter of 2024. This figure grew by 123.6% compared to the same period last year, which was Rp 1.82 billion.
            </p>
            <p>
            MPX Logistics International (MPXL) President Director Wijaya Candera stated that the increase in net profit is in line with the increase in revenue from material and transport services located in the Nusantara Capital project. "In addition, the company's revenue is supported by the increased transportation of PLTU (FaBa) coal waste," Wijaya said in a press release on Tuesday (7/5/2024).
            </p>
            <p>
            Throughout the first quarter of 2024, Wijaya continued, MPXL recorded consolidated net revenue increased by 60.24% YoY to Rp 45.42 billion in the first quarter of 2024 from Rp 28.3 billion in the first quarter of 2023. This growth is due to an increase in transport service revenue by 149.21% to Rp 24.8 billion in the first quarter of 2024 compared to the same period last year, which was Rp 9.9 billion.
            </p>
            <p>
            "And, there is a growth in material sales of 12.1% to Rp 20.6 billion in the first quarter of 2024 compared to the same period last year, which was Rp 18 billion," explained Wijaya.
            </p>
            <p>
            Wijaya added that in the future, MPXL will continue to focus on the Material trading and transport service segments, which are the core business of the Company, by continuing to develop other logistics transportation such as fly ash, bottom ash, clinker, lime stone, and coal. This year, the company has added 50 units of new tronton truck fleets to meet the increased transportation demand from the company's long-term business contracts.
            </p>
            <p>
            "These new fleets are projected to increase revenue by Rp 50 billion. Thus, the company's target of Rp 222 billion in 2024 can be achieved. Not only to increase revenue but also to contribute positively to economic growth in the transportation and logistics sectors," he said.
            </p>
            <p>
            Furthermore, Wijaya stated that the company, through its subsidiary MPX Indorental Gemilang, has also formed a strategic partnership with a 5-year contract with Power China in providing heavy equipment to be operated in the andesite stone mining area located in Palu, Central Sulawesi.
            </p>
            <p>
            "In addition, the company is also exploring transportation services for andesite stone from the mining area by barge to be sent to the Nusantara Capital, East Kalimantan," he concluded.
            </p>
          <div style={{ width:"100%", paddingTop:"4em" }}>
            {/* <div style={{ width:"70%"}}> */}
                <TradingViewWidget />
            {/* </div> */}
          </div>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://investor.id/market/361014/laba-mpx-logistics-mpxl-meroket-1236-ini-penopangnya"
                target="_blank"
                rel="noreferrer"
              >
              https://investor.id/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {

      id: 12,
      title:"MPX Logistics (MPXL) Agrees to Distribute Rp3 Billion in Dividends",
      url:"MPX-Logistics-(MPXL)-Sepakat-Bagi-Dividen-Rp3-Miliar",
      image:"/images/artikel/mpx-logistics-mpxl-sepakat-bagi-dividen-rp3-miliar.jpg",
      date:"Wednesday, 24 April, 2024 | 10:46 AM",
      preview:"PT MPX Logistics International Tbk (MPXL) has agreed to distribute dividends amounting to Rp3 billion in the Annual General Meeting of Shareholders (AGM) on Tuesday (23/4/2024).",
      desc: (
        <>
          <p>
          <strong>IDXChannel </strong>
          - PT MPX Logistics International Tbk (MPXL) has agreed to distribute dividends amounting to Rp3 billion in the Annual General Meeting of Shareholders (AGM) on Tuesday (23/4/2024).
          </p>
          <p>
              A sum of Rp2 billion has already been distributed as interim dividends on November 17, 2023. Meanwhile, the remainder of the consolidated net profit after dividend distribution and general reserves is recorded as retained earnings to finance the company's working capital.
          </p>
          <p>
              "The dividends will be distributed in cash to shareholders whose names are listed in the Shareholder List as of May 6, 2024," said MPXL's CEO, Wijaya Candera, in his official statement on Wednesday (24/4/2024).
          </p>
          <p>
              Wijaya explained that the allocation of net profit as dividends is a manifestation of the company's commitment to adding value to its shareholders.
          </p>
          <p>
              "The dividend distribution has considered the profit or positive balance of the fiscal year and the company's obligation to allocate reserves according to applicable regulations and financial conditions. Future business growth rates are also considerations in dividend distribution," Wijaya said.
          </p>
          <p>
              MPXL achieved positive results throughout 2023. Consolidated net income increased by 19.9% YoY to Rp140 million, supported by revenue growth from the transportation services segment and the material trading segment.
          </p>
          <p>
              "This increase in net income demonstrates the company's effective strategy in managing the economic situation and maintaining profitability," said Wijaya.
          </p>
          <p>
              In addition to dividend distribution, the AGM also decided to appoint Budi Chandra, who is the Director of PT BOLDE Indonesia and a shareholder of the company, as a commissioner to complement the existing board of commissioners.
          </p>
          <p>
              Here is the latest composition of the board of commissioners:
          </p>
          <p>
              * President Commissioner: Ye Hun Ki <br/>
              * Commissioner: Budi Chandra <br/>
              * Independent Commissioner: Katherine Judy
          </p>
          <p>
          <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.idxchannel.com/market-news/mpx-logistics-mpxl-sepakat-bagi-dividen-rp3-miliar"
                target="_blank"
                rel="noreferrer"
              >
               https://www.idxchannel.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 11,
      title:"MPX Logistics (MPXL) Receives Credit from BCA, Check Out the Plan",
      url:"MPX-Logistics-(MPXL)-Raih-Kredit-dari-BCA,-Simak-Rencananya",
      image:"/images/artikel/pelni-angkutan-barang-1.jpg",
      date:"Monday, 20 November, 2023 |  11:07 AM",
      preview:"PT MPX Logistics International Tbk. (MPXL) received a credit facility of IDR 40.94 billion from PT Bank Central Asia Tbk. (BBCA).",
      desc: (
        <>
          <p>
            <strong> Bisnis.com, </strong>
           JAKARTA - Transportation and logistics issuer, PT MPX Logistics International Tbk. (MPXL) received a credit facility of IDR 40.94 billion from PT Bank Central Asia Tbk. (BBCA). The plan is that the loan will be used to expand the truck fleet and build a workshop.
          </p>
          <p>
           MPXL Corporate Secretary Nilam Sari Siregar said that the signing of the credit agreement with BBCA was carried out on Thursday, November 16 2023.
          </p>
          <p>
             "This investment credit will be used to finance the purchase of a new truck fleet, construction of the company's garage and workshop," he said, quoted from the IDX information disclosure on Monday (20/11/2023).
          </p>
          <p>
            Meanwhile, the impact of the credit facility received from Bank BCA includes the purchase of a new fleet of tow trucks for the Indonesian Capital City (IKN) and toll road projects.
          </p>
          <p>
           "The company's revenue or income increases so that the company's business activities develop," concluded Nilam.
          </p>
          <p>
            Looking at its financial performance, MPXL recorded revenue of IDR 97.77 billion per quarter III/2023, or an increase of 13% year-on-year (yoy) compared to the same period in 2022 of IDR 86.51 billion.
          </p>
          <p>
            In detail by segment, MPXL's revenue is supported by material sales amounting to IDR 60.61 billion, and expedition services amounting to IDR 37.15 billion.
          </p>
          <p>
             From the bottom line, MPXL's net profit jumped 54.75% yoy to IDR 7.67 billion as of September 30 2023, compared to the same period in 2022 of IDR 4.96 billion. From the bottom line, MPXL's net profit jumped 54.75% yoy to IDR 7.67 billion as of September 30 2023, compared to the same period in 2022 of IDR 4.96 billion.
          </p>
          <p>
             For your information, MPXL often gets credit facilities from Bank BCA (BBCA). Previously, in October 2023, MPXL also received a credit of IDR 25 billion from BBCA to increase its truck fleet.
          </p>
          <p>
             At that time, MPXL purchased 23 large trucks to boost the company's performance. In detail, MPXL bought 20 units of hi-blow trailer type trucks, and 3 units of hi-blow trailer type trucks.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://market.bisnis.com/read/20231120/192/1715963/mpx-logistics-mpxl-raih-kredit-dari-bca-simak-rencananya"
                target="_blank"
                rel="noreferrer"
              >
                https://market.bisnis.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 10,
      title:
        "MPXL Ready to Distribute IDR 2 Billion in Dividends, Check the Schedule",
      url: "MPXL-Siap-Tebar-Dividen-Rp2-Miliar,-Cek-Jadwalnya",
      image:
        "/images/artikel/MPXL-Siap-Tebar-Dividen-Rp2-Miliar,-Cek-Jadwalnya.jpg",
      date: "Thursday, October 19, 2023 | 10:53 AM",
      preview:
        "PT MPX Logistics International Tbk (MPXL) plans to distribute a 2023 fiscal year interim dividend amounting to IDR 2 billion.",
      desc: (
        <>
          <p>
            <strong>IDXChannel</strong> - PT MPX Logistics International Tbk (MPXL) plans to distribute a 2023 fiscal year interim dividend amounting to IDR 2 billion.
            This decision received approval from the company's Board of Commissioners on October 17, 2023.
          </p>
          <p>
          "The company's board of directors has decided to distribute an interim dividend from the company's profit for the fiscal year ending on December 31, 2023,
           amounting to IDR 1 per share," said MPXL's Corporate Secretary, Nilam Sari Siregar, in a disclosure on Thursday, October 19, 2023.
          </p>
          <p>
          Nilam mentioned that the interim dividend will be distributed to shareholders whose names are recorded on the Shareholder
          List or the company's recording date on October 31, 2023, at 4:00 PM WIB (Western Indonesia Time).
          </p>
          <p>
          The schedule for MPXL dividend distribution is as follows:
              <ol>
                <li>Cum Dividend in the Regular Market and Negotiated Market: October 27, 2023 </li>
                <li>Ex Dividend in the Regular Market and Negotiated Market: October 30, 2023  </li>
                <li>Cum Dividend for Cash Market trading: October 31, 2023</li>
                <li>Ex Dividend for Cash Market trading: November 1, 2023 </li>
                <li>Recording Date for dividend entitlement: October 31, 2023, at 4:00 PM WIB </li>
                <li>Dividend Payment: November 17, 2023 </li>
              </ol>
          </p>
         <p>
         As of June 2023, MPXL has recorded a current-year profit of IDR 4.34 billion, an increase from the same period the previous year, which was IDR 3.40 billion.
          </p>
         <p>
         Meanwhile, the company's revenue is recorded at IDR 63.50 billion, an increase from the previous figure of IDR 51.38 billion. Specifically,
         material sales amounted to IDR 40.20 billion, and revenue from expedition services amounted to IDR 23.30 billion.
          </p>

          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Source :{" "}
              <a
                href="https://www.idxchannel.com/market-news/mpxl-siap-tebar-dividen-rp2-miliar-cek-jadwalnya/all"
                target="_blank"
                rel="noreferrer"
              >
                https://www.idxchannel.com
              </a>
            </span>
          </p>
        </>
      ),
    },

    {
      id: 9,
      title:
        "Joining the IKN project, MPX Logistics (MPXL) has begun sending material transport fleets.",
      url: "Ikut-Bangun-IKN,-MPX-Logistics-MPXL-Mulai-Kirim-Armada-Pengangkut-Material",
      image:
        "/images/artikel/Ikut-Bangun-IKN,-MPX-Logistics-MPXL-Mulai-Kirim-Armada-Pengangkut-Material.jpg",
      date: "Monday, September 4, 2023 | 04:03 PM",
      preview:
        "PT MPX Logistics International Tbk (MPXL) has started sending a number of its fleet units to the IKN Nusantara area in East Kalimantan.",
      desc: (
        <>
          <p>
            <strong>IDXChannel</strong> - PT MPX Logistics International Tbk
            (MPXL) has begun sending a number of its fleet units to the IKN
            Nusantara area in East Kalimantan.
          </p>
          <p>
            MPXL is involved in material transport services for the construction
            of the new capital city's area. In the initial phase, MPXL is
            sending a total of 5 Hi-Blow Tronton fleet units for the bulk cement
            transportation project.
          </p>
          <p>
            The total fleet that will play a crucial role in the development of
            IKN consists of 50 truck units. The combined capacity
            (transportation capability) of these 50 truck fleets is
            approximately 36,000 tons of bulk cement per month.
          </p>
          <p>
            This will ensure a constant supply of materials for the construction
            of IKN, facilitating smooth casting processes for both state-owned
            enterprises (BUMN Karya) and private companies.
          </p>
          <p>
            The company is currently collaborating with Cemindo Gemilang Tbk
            (CMNT) to deliver bulk cement materials to the IKN project site.
          </p>
          <p>
            MPXL Director Wijaya Candera stated that the company is in the
            process of discussing the schedule for truck fleet deliveries after
            participating in the tender for bulk cement material transport
            services for the IKN project, which was organized by PT Indocement
            Tunggal Prakarsa Tbk (INTP).
          </p>
          <p>
            "This IKN material transport project will have a positive impact on
            increasing the company's revenue year by year because it is a
            long-term development project. The construction of IKN represents a
            new chapter in creating a new civilization. We want MPXL to be able
            to contribute to the creation of this new history in Indonesia,"
            said Wijaya in an official statement on Thursday, August 31, 2023.
          </p>
          <p>
            For your information, PT MPX Logistics International Tbk has secured
            contracts with several companies for material transport services,
            including PT Conch Cement Indonesia, BUT Synohidro Corporation, and
            PT Indocement Tunggal Prakarsa Tbk.
          </p>
          <p>
            MPXL officially listed its shares on the Indonesia Stock Exchange
            (BEI) on Tuesday, May 9, 2023. Through its initial public offering
            (IPO), the company has the potential to raise fresh funds amounting
            to Rp43.20 billion.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.idxchannel.com/market-news/ikut-bangun-ikn-mpx-logistics-mpxl-mulai-kirim-armada-pengangkut-material"
                target="_blank"
                rel="noreferrer"
              >
                https://www.idxchannel.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 8,
      title:
        "MPX Logistics (MPXL) Expansion: Profiting from Construction Material Transportation",
      url: "Ekspansi-MPX-Logistics-(MPXL)-Mengangkut-Cuan-dari-Material-Konstruksi",
      image:
        "/images/artikel/Ekspansi-MPX-Logistics-(MPXL)-Mengangkut-Cuan-dari-Material-Konstruksi.jpg",
      date: "Friday, August 11, 2023 | 09:26 AM",
      preview:
        " PT MPX Logistics International Tbk (MPXL) is exploring the potential for profit from construction material transportation services. With promising prospects, MPXL is currently pushing for expansion amid the ongoing wheels of development.",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID - JAKARTA. </strong> PT MPX Logistics
            International Tbk (MPXL) is exploring the potential for profit from
            construction material transportation services. With promising
            prospects, MPXL is currently pushing for expansion amid the ongoing
            wheels of development.
          </p>
          <p>
            The company that went public on the Indonesia Stock Exchange (IDX)
            on May 9, 2023, specializes in transportation services in the
            construction sector. In addition to transportation, MPXL engages in
            trading activities of materials, particularly cement as well as Fly
            Ash and Bottom Ash (FABA).
          </p>
          <p>
            MPXL is registered with the Ministry of Environment as one of the
            largest carriers of FABA waste. The majority of MPXL's customers are
            cement companies and Steam Power Plants (PLTU).
          </p>
          <p>
            Following the Initial Public Offering (IPO), MPXL is actively
            pursuing new contracts and customers. Some time ago, MPXL partnered
            with the Sinohydro-NEM Consortium to supply cement for the
            construction of the Amman Mineral Smelter in Sumbawa, West Nusa
            Tenggara.
          </p>
          <p>
            MPXL has begun transporting cement to Sumbawa this July, with an
            initial transport volume of 2,300 tons. MPXL will make several
            deliveries to Sumbawa gradually over the next 18 months.
          </p>
          <p>
            MPXL has also signed a contract for transporting 660,000 tons of
            PLTU FABA from a Chinese cement company investing in Indonesia,
            namely PT Conch Cement Indonesia. The acquisition of this contract
            has boosted MPXL's confidence to enhance its performance this year.
          </p>
          <p>
            Moreover, the performance for the first half of 2023 for MPXL has
            been impressive. MPXL recorded revenues of Rp 63.50 billion up to
            June 2023, showing a growth of 23.58% compared to the same period
            last year.
          </p>
          <p>
            MPXL reported a year-to-date profit of Rp 4.34 billion, marking a
            27.64% increase from the first six months of 2022. CEO of MPXL,
            Wijaya Candera, mentioned that the addition of new contracts with
            significant values has been the main driver.
          </p>
          <p>
            "Additionally, it's due to increased demand for our transportation
            services from existing customers. Also, it's because of the
            enhancement in our transportation productivity," said Wijaya to
            Kontan.co.id on Friday (July 28).
          </p>
          <p>
            Wijaya projected that MPXL's revenue for the entire year of 2023
            could reach Rp 155 billion, indicating a 34% annual increase.
            Meanwhile, the estimated growth in MPXL's net profit is expected to
            reach 103%, totaling Rp 12.2 billion.
          </p>
          <p>
            <strong>Boosting Expansion</strong>
          </p>
          <p>
            In order to achieve sustainable growth targets, MPXL is preparing a
            number of expansion initiatives. Among them is considering business
            opportunities from the Nusantara Capital City (IKN) project in East
            Kalimantan.
          </p>
          <p>
            "We have conducted surveys at the IKN and have started preparing our
            vehicle units to operate with our partners for the IKN project,"
            Wijaya stated.
          </p>
          <p>
            Another strategy, MPXL is preparing a new division to expand into
            the heavy equipment segment. "We are also in negotiations with
            partners to secure heavy equipment rental projects and plan to
            commence operations in the fourth quarter of 2023," added Wijaya.
          </p>
          <p>
            To support these strategies, MPXL is ramping up its capital
            expenditure (capex). MPXL has increased its capex budget from the
            previous plan of Rp 20 billion to Rp 32 billion.
          </p>
          <p>
            The allocated capex for MPXL is designated for land purchase and
            vehicle pool renovations, as well as down payments for the
            acquisition of 38 truck units. By the end of the first semester, 55%
            of the capex budget has been utilized.
          </p>
          <p>
            In alignment with this, MPXL is also efficiently utilizing the funds
            from the public offering. According to the report as of June 30,
            2023, MPXL has utilized Rp 35.28 billion for working capital, land
            acquisition, and down payments for truck purchases.
          </p>
          <p>
            This implies that within a span of approximately two months, MPXL
            has utilized 90.04% of the net proceeds from the IPO. MPXL issued
            400 million new shares, equivalent to 20% ownership, during the IPO.
          </p>
          <p>
            With an offering price of Rp 108 per share, MPXL raised fresh funds
            amounting to Rp 43.20 billion. After deducting the costs of the
            public offering, MPXL's net proceeds amounted to Rp 39.18 billion.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Source :{" "}
              <a
                href="https://investasi.kontan.co.id/news/ekspansi-mpx-logistics-mpxl-mengangkut-cuan-dari-material-konstruksi"
                target="_blank"
                rel="noreferrer"
              >
                https://investasi.kontan.co.id
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 7,
      title:
        "MPX Logistics (MPXL) Wins Contract to Transport 660 Thousand Tons of FABA for PLTU",
      url: "MPX-Logistics-(MPXL)-Raih-Kontrak-Angkut-FABA-PLTU-660-Ribu-Ton",
      image:
        "/images/artikel/MPX-Logistics-(MPXL)-Raih-Kontrak-Angkut-FABA-PLTU-660-Ribu-Ton.jpg",
      date: "Thursday, July 20, 2023 | 11:38 AM",
      preview:
        "PT MPX Logistics International Tbk (MPXL) has won a contract to transport 660,000 tons of Fly Ash and Bottom Ash (FABA) for a coal-fired power plant (PLTU) with the giant cement company from China, PT CONCH Cement Indonesia.",
      desc: (
        <>
          <p>
            <strong>IDXChannel</strong> - PT MPX Logistics International Tbk
            (MPXL) has secured a contract for transporting 660,000 tons of Fly
            Ash and Bottom Ash (FABA) for a coal-fired power plant (PLTU) with
            the giant cement company from China, PT CONCH Cement Indonesia.
          </p>
          <p>
            This additional contract is estimated to be worth Rp35 billion.
            Under this contract, the transportation and logistics company will
            transport the coal-fired power plant's coal waste to the Cement
            Factory's location for utilization.
          </p>
          <p>
            Fly Ash and Bottom Ash are ashes produced during the coal burning
            process in a coal-fired power plant (PLTU). The use of FABA in the
            cement industry and infrastructure is becoming increasingly popular
            due to its environmentally friendly nature, as it helps reduce
            environmental pollution.
          </p>
          <p>
            "In addition to providing financial benefits for PT MPX Logistics
            International Tbk, this contract will also enhance the company's
            image as a reliable partner in the logistics industry. With the
            experience and expertise we possess, MPX Logistics can ensure timely
            and professional deliveries to the cement company," said Wijaya
            Candera, the CEO of MPX Logistics International, in an official
            statement on Wednesday (July 12, 2023).
          </p>
          <p>
            MPXL is optimistic that the performance increase in the second half
            of 2023 will exceed the company's set target. The contract period
            itself is for two years and will end in July 2025.
          </p>
          <p>
            Throughout the first half of 2023, MPXL's revenue recorded a
            year-on-year growth of 24%, reaching Rp63.5 billion compared to
            Rp51.3 billion in the first half of 2022. The revenue increase was
            supported by sales in the material segment for the Amman Smelter
            Sumbawa project and the paper mill project in Kaltara.
          </p>
          <p>
            On the profit side, there was a positive growth of 28% year on year
            (yoy), with MPXL's profit reaching Rp4.35 billion compared to Rp3.39
            billion in the first half of 2022. The company's assets increased by
            95% to Rp116.5 billion from the previous value of Rp59.74 billion,
            and its equity also recorded an increase to Rp86.3 billion in the
            financial report as of June 30, 2023.
          </p>
          <p>
            "We expect the company's performance to continue growing as we
            commence operations with 10 new tronton tank trucks this July.
            Additionally, the company has placed orders for 5 new Trailer trucks
            and 10 dump tronton trucks to meet the transportation contract
            demands for FABA from the coal-fired power plant," added Wijaya.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Source :{" "}
              <a
                href="https://www.idxchannel.com/market-news/mpx-logistics-mpxl-raih-kontrak-angkut-faba-pltu-660-ribu-ton"
                target="_blank"
                rel="noreferrer"
              >
                https://www.idxchannel.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 6,
      title:
        "MPXL Logistics Signs Strategic Partnership MoU with TopFortune China Company",
      url: "MPXL-Logistics-Tandatangi-MoU-Kemitraan-Strategis-dengan-Perusahaan-TopFortune-China",
      image:
        "/images/artikel/MPXL-Logistics-Tandatangi-MoU-Kemitraan-Strategis-dengan-Perusahaan-TopFortune-China.jpg",
      date: "Monday, June 05, 2023 | 02:38 PM",
      preview:
        "PT MPX Logistics International Tbk (MPXL) has signed a strategic partnership contract with PT. China West Development Indonesia for the delivery of materials worth IDR 130 billion over 15 months, as well as the rental of heavy equipment.",
      desc: (
        <>
          <p>
            <strong>Bisnis.com,</strong> MPX Logistics International (MPXL Tbk),
            a leading international logistics company, announced yesterday,
            Wednesday (31/5), the signing of a strategic partnership contract
            with PT. China West Development Indonesia for projects in Indonesia.
            This MoU also includes the purchase of more than 100,000 tons of
            bulk OPC cement.
          </p>
          <p>
            As a subsidiary of China State Construction Corporation (CSCEC), PT.
            China West Development Indonesia is a reputable construction
            company. From the data we have, CSCEC is the largest public company
            in the Concrete Industry in China and is one of the Top Fortune 500
            companies in China. Furthermore, this Chinese company is also among
            the top 20 companies in the building materials industry in China.
          </p>
          <p>
            The signing took place at the Swissotel Jakarta PIK Avenue. This
            memorandum of understanding marks the initial agreement for close
            cooperation between MPX Logistics International and PT. China West
            Development Indonesia. MPXL will act as the logistics and
            transportation provider for construction projects carried out by PT.
            China West Development Indonesia in Indonesia.
          </p>
          <p>
            "We are very proud to work on projects with PT. China West
            Development Indonesia to support infrastructure development in
            Indonesia," said Wijaya Candera, CEO of MPX Logistics International.
          </p>
          <p>
            "This partnership will ensure efficient, reliable, and measurable
            delivery of construction materials to project sites," he added.
          </p>
          <p>
            The first project to be undertaken is the Pulp Project in Tarakan,
            also known as the Phoenix Resources International Project, in North
            Kalimantan. MPXL will arrange the delivery of materials worth IDR
            130 billion over 15 months, as well as the rental of heavy
            equipment.
          </p>
          <p>
            North Kalimantan itself is currently one of the provinces that will
            develop a Hydropower Plant (PLTA) and the Indonesian Green
            Industrial Zone (KIHI). This will increase investments from national
            and multinational companies due to the availability of cheap and
            environmentally friendly green energy sources.
          </p>
          <p>
            MPXL has extensive experience and knowledge in the logistics
            industry, including transportation networks, project materials, and
            warehousing. The signing of this MoU will allow MPXL to utilize its
            expertise in providing timely and efficient expedition and logistics
            arrangements.
          </p>
          <p>
            "The signing of this MoU is a testament to the trust of our
            partners, and with this MoU, MPXL officially enters the heavy
            equipment rental business as a new division of our company. I hope
            this collaboration can serve as a reference for us to always be
            enthusiastic about exploring new projects and actively contribute to
            infrastructure development in Indonesia," he explained.
          </p>
          <p>
            MPXL continues to strive to develop a strong logistics network and
            assist national and international companies in meeting their
            logistics needs. Through this strategic partnership, MPXL will
            strengthen its position in the Indonesian logistics industry and
            help advance infrastructure development in Indonesia.
          </p>
          <p>
            As a leading logistics company, MPX Logistics has a vision to
            provide excellent and reliable services to customers throughout
            Indonesia. With this strategic partnership, MPXL will add value to
            projects in Indonesia through timely and efficient delivery of
            materials.
          </p>
          <p>
            This strategic partnership contract is an important step forward for
            MPXL in strengthening its position as a leading logistics provider
            capable of overcoming logistical challenges in Indonesia.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Source :{" "}
              <a
                href="https://amp.kontan.co.id/news/mpxl-logistics-tandatangi-mou-kemitraan-strategis-dengan-perusahaan-topfortune-china"
                target="_blank"
                rel="noreferrer"
              >
                https://www.kontan.co.id
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 5,
      title:
        "PT MPX Logistics International Tbk (MPXL), which has just officially go public, has partnered with Sinohydro-Nem Consortium or a subsidiary of Power China Group in the Mega Project Amman Smelter in Sumbawa.",
      url: "PT-MPX-Logistics-International-Tbk-(MPXL)-Digandeng-dalam-Mega-Project-Amman-Smelter",
      image:
        "/images/artikel/PT-MPX-Logistics-International-Tbk-(MPXL)-Digandeng-dalam-Mega-Project-Amman-Smelter.jpg",
      date: "Monday, June 05, 2023 | 10:24 AM",
      preview:
        "PT. MPX Logistics International Tbk (MPXL), one of the infrastructure supporting transportation services and coal waste carrier Fly Ash and Bottom Ash (FABA) plans to conduct an initial public offering (IPO) of shares by releasing 400 million new shares or around 20% of the issued capital and fully paid.",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID</strong> - PT MPX Logistics International Tbk
            (MPXL), one of the infrastructure transportation services and
            materials trading companies that recently went public, was directly
            partnered with SINOHYDRO-NEM CONSORTIUM or a Power China Subsidiary
            to cooperate in the construction of the Amman Mineral Smelter Mega
            Project in West Sumbawa Regency, West Nusa Tenggara Province.
          </p>
          <p>
            On Monday (15/05). PT MPX Logistics International Tbk (MPXL) signed
            an official contract with Sinohydro, in this partnership PT MPX
            Logistics International Tbk (MPXL) obtained contracts for
            transportation services and materials supply, especially bulk cement
            types OPC and type V at the Sumbawa Safe Mineral Smelter project,
            with a total capacity of 100,000 tons.
          </p>
          <p>
            The company previously obtained a Dumptruk car rental service
            contract and is currently operating at the Amman Mineral Smelter
            project.
          </p>
          <p>
            "The contract that we have signed will be valid for the next 18
            months.We’re hoping that with this project in Sumbawa, MPXL can work
            with companies in other parts of Eastern Indonesia." MPXL Director
            Susanto said
          </p>
          <p>
            "MPXL does not only provide transportation services or as a supplier
            of materials, but also as a transportation partner for existing coal
            ash transporters for power plants (PLTU). MPXL is committed to
            always providing transportation services and supplying good quality
            material needs to support government and community projects in order
            to build infrastructure for an advanced Indonesia 2045.” explained
            Susanto, Director of PT MPX Logistics International Tbk (MPXL).
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Source :{" "}
              <a
                href="https://pressrelease.kontan.co.id/news/pt-mpx-logistics-international-tbk-mpxl-digandeng-dalam-mega-project-amman-smelter"
                target="_blank"
                rel="noreferrer"
              >
                https://pressrelease.kontan.co.id
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 4,
      title:
        "MPX Logistics International Tbk IPO Offers a Price of IDR 103-110 per Share",
      url: "MPX-Logistics-International-IPO-Tawarkan-Harga-Rp103-Rp110-per-Saham",
      image:
        "/images/artikel/MPX-Logistics-International-IPO-Tawarkan-Harga-Rp103-Rp110-per-Saham.jpg",
      date: "Tuesday, April 11, 2022 | 11:18 PM",
      preview:
        "PT. MPX Logistics International Tbk (MPXL), one of the infrastructure supporting transportation services and coal waste carrier Fly Ash and Bottom Ash (FABA) plans to conduct an initial public offering (IPO) of shares by releasing 400 million new shares or around 20% of the issued capital and fully paid.",
      desc: (
        <>
          <p>
            <strong>
              JAKARTA, April 11th, 2023 - PT. MPX Logistics International Tbk
              (MPXL)
            </strong>
            , one of the infrastructure transportation service companies and
            carriers of coal waste Fly Ash and Bottom Ash (FABA), plans to
            conduct an initial public offering (IPO) by releasing 400 million
            new shares or approximately 20% of the issued and fully paid-up
            capital.
          </p>
          <p>
            The offering price is around Rp103-Rp110 per share. Therefore, the
            funds that the company will raise are estimated to be around Rp41.2
            billion to Rp44 billion.
          </p>
          <p>
            Along with the IPO, the company will also issue up to 80 million
            Series I Warrants, or equivalent to up to 5% of the total number of
            issued and fully paid-up shares. The Series I Warrants will be given
            as an incentive to new shareholders and will be distributed for
            free.
          </p>
          <p>
            For every 5 new shares of the company, the shareholder is entitled
            to receive 1 Series I Warrant, which can be exchanged for 1 ordinary
            share. The exercise price range is Rp198-Rp368 per share, which can
            be exercised after 6 months since the Series I Warrants are issued,
            starting from November 9th, 2023 until May 8th, 2024. Through this
            offering, the company will raise funds of approximately Rp15.8
            billion to Rp29.4 billion.
          </p>
          <p>
            PT Panin Sekuritas Tbk (PANS) will act as the underwriter for the
            securities issuance.
          </p>
          <p>
            <strong>
              The CEO of PT. MPX Logistics International Tbk (MPXL), Wijaya
              Candera,
            </strong>{" "}
            stated that the funds raised from this corporate action, after
            deducting the costs of securities issuance, will be allocated as
            follows: approximately 12.7% for the down payment of purchasing a
            fleet of trucks. The company has ordered 10 units of vehicles with a
            price of around Rp1.3 billion per vehicle, including the Tanki body,
            to increase the company's revenue. The remaining 36.9% will be used
            to purchase land and buildings in Banten Province to support and
            facilitate the company's activities.
          </p>
          <p>
            The remaining approximately 50.2% of the funds raised will be used
            by the company for working capital, including purchasing materials,
            operational expenses, vehicle maintenance, vehicle licensing, other
            office expenses, payment of trade payables, and payment of accruals.
          </p>
          <p>
            "While the implementation of our offered Series I Warrant is aimed
            to attract investors' interest, it will be fully used for Working
            Capital, which includes purchasing materials, operational costs,
            vehicle maintenance, vehicle licensing management, other office
            expenses, and trade debt settlement," as stated in the press release
            on Tuesday, April 11th, 2023.
          </p>
          <p>
            Wijaya stated that currently, in addition to providing
            infrastructure support transportation services, the company is also
            engaged in trading activities, specifically in bulk cement and FABA
            (Fly Ash Brick Aggregate) materials.
          </p>
          <p>
            According to Wijaya, the future performance prospects of the company
            will be very good, with one of the indications being the stable
            performance of the cement industry last year, coupled with the trend
            of improving cement consumption that has been occurring since the
            previous year or in 2021, which grew by 4.3% after experiencing a
            10.7% annual growth contraction in 2020.
          </p>
          <p>
            "It is expected that both consumption and production capacity trends
            will continue to improve in line with the government's focus on
            building the New Capital City (IKN) in East Kalimantan. With the
            development of the IKN, this will have a domino effect on
            infrastructure development and supporting facilities, in addition to
            the development of supporting properties such as office buildings
            and housing. Automatically, this will boost national cement
            consumption and have an impact on the company's business," he said.
          </p>
          <p>
            In addition, the company will continue to pursue a number of growth
            strategies, one of which is to offer collaborations with companies
            that produce products needed by the company's customers, such as
            cement factories, power plants, and the mining sector.
          </p>
          <p>
            Not only that, the Company will also seek customers who need cement,
            FABA products, and mining products such as cement plants,
            lightweight brick plants, batching plants, distributors, and
            contractors for infrastructure projects.
          </p>
          <p>
            The other side of the Company will continue to cultivate good
            relationships with both suppliers and customers by providing the
            best service. Lastly, the Company will ensure accurate time
            management in meeting the expectations of existing customers as well
            as reaching out to more new customers.
          </p>
          <p>
            "As for adding new fleets from the proceeds of this Public Offering
            in order to increase the volume of transportation and material
            sales. With adequate fleets, the Company can improve the speed and
            accuracy of delivery to customers," he said.
          </p>
          <p>
            The plan is to list the stock and Series I Warrants on May 9, 2023.
            The offering period will take place from April 11-14, 2023.
            Furthermore, the initial public offering of shares will take place
            from May 3-5, 2023, and electronic distribution will occur on May 8,
            2023.
          </p>
        </>
      ),
    },
    {
      id: 3,
      title:
        "MPX Logistics International Tbk has successfully won 2 international certifications",
      url: "MPX-Logistics-International-berhasil-raih-2-sertifikasi-internasional",
      image:
        "/images/artikel/MPX-Logistics-International-berhasil-raih-2-sertifikasi-internasional.jpeg",
      date: "Tuesday, November 01, 2022 | 2:03 PM",
      preview:
        "The implementation of the Quality management system and Occupational Health and Safety management system (SMK3) is an absolute requirement for the continuity of operational activities in the logistics sector",
      desc: (
        <>
          <p>
            The implementation of a Quality management system and an
            Occupational Health and Safety (SMK3) management system is an
            absolute requirement for the continuity of operational activities in
            the logistics sector. Apart from being a supporter in the commitment
            to provide the best service to customers, it also provides
            protection and a safe work environment for every worker involved in
            it.
          </p>
          <p>
            PT. MPX Logistics International Tbk, has succeeded in obtaining ISO
            9001: 2015 Quality management system certification and ISO 45001:
            2018 Occupational Health and Safety management system certification
            on May 25, 2022.
          </p>
          <p>
            Wijaya Candera, as the Main Director of PT MPX Logistics
            International said, the achievement of this international standard
            certification is a manifestation of the company's vision to become a
            logistics company in Indonesia that has international class and
            service standards.
          </p>
          <p>
            ISO 9001:2015 is an international quality management system
            standard, which aims to guarantee that products or services provided
            by companies meet the requirements set by the world standard body
            (ISO). When the company is declared to have passed after going
            through a long process and going through the final stages of the
            audit, it means that the company has met the requirements that have
            been set internationally in the responsibility of providing quality
            assurance for the products or services provided.
          </p>
          <p>
            Meanwhile, ISO 45001: 2018 is an international standard on the
            Occupational Health and Safety management system (SMK3) to minimize
            the risk of work accidents, as well as create a safe and healthy
            workplace for every worker, partner, visitor and customer.
          </p>
          <p>
            ISO certification also routinely reviews the systems that have been
            implemented in the company, as well as the responsibilities of
            company leaders and employee participation in maintaining the
            quality and K3 standards that have been set and whether it
            consistently identifies risks, assesses consequences and also
            determines appropriate control methods and effective.
          </p>
          <p>
            It doesn't stop here, in the future PT. MPX Logistics International
            Tbk will continue to carry out continuous improvisation on the
            management system in the company to support the achievement of the
            company's vision and mission.
          </p>
        </>
      ),
    },
    {
      id: 2,
      title:
        "Support Company Expansion MPX International Explores Funding from the Capital Market",
      url: "Dukung-Ekspansi-Perusahaan-MPX-International-Jajaki-Pendanaan-dari-Pasar-Modal",
      image:
        "/images/artikel/Dukung-Ekspansi-Perusahaan-MPX-International-Jajaki-Pendanaan-dari-Pasar-Modal.jpg",
      date: "Sunday, October 31, 2021 | 10:57 PM",
      preview:
        "MPX Logistics International Tbk as a company engaged in the field of transportation and logistics services, is optimistic that the Indonesian economy will improve.",
      desc: (
        <>
          <p>
            <strong>Jakarta, Beritasatu.com</strong> - MPX Logistics
            International as a company engaged in the field of transportation
            and logistics services, is optimistic that the Indonesian economy
            will improve. Main Director of MPX Logistics International Tbk,
            Wijaya Candera said the current business concept of MPX Logistics
            International, is a business to business (B2B) and business to
            customer (B2C) company that is committed to maintaining the trust of
            all relationships business and society, in order to create good
            long-term cooperation.
          </p>
          <p>
            "We have been present since 2008, where our regular clients are
            national and international companies, such as Astra International,
            Wings Group, PT Sinar Sosro, Shell Helix, Semen Indonesia Group,
            Indocement, Conch Semen, Sinohydro and many others," said Wijaya, in
            his statement to Beritasatu.com, Sunday (31/10/2021).{" "}
          </p>
          <p>
            Departing from the existing cooperation, continued Wijaya, MPX is
            optimistic that in 2022 it can achieve better growth. Moreover,
            business opportunities in the field of transportation and logistics
            are now starting to rise. "Even though last year, in Indonesia or
            internationally the economy had crashed due to the Covid-19
            pandemic, however, the distribution of vaccines which continues to
            be evenly distributed globally, makes us optimistic that this
            pandemic will pass, "explained Wijaya.
          </p>
          <p>
            According to him, the right business strategy is the key in facing
            the market. One of the business strategies that will be implemented
            by MPX Logistic International is, carries the concept of go digital,
            where everything will be easier and faster when done digitally
            entering the era of the industrial revolution 4.0.
          </p>
          <p>
            Wijaya said that the go digital concept would be launched through
            the MPXGO application, so that it would be easy for the public to
            access information regarding expected transportation and logistics
            costs. "By expanding the transportation and logistics service area
            to all parts of Indonesia, even to the international arena, become
            our provision to support government programs in the digitalization
            era going forward," said Wijaya.
          </p>
          <p>
            Another strategy, the company will seek funding from the capital
            market to support the company's expansion. Thus, corporate
            governance becomes better, and can create more jobs for the
            community.
          </p>
        </>
      ),
    },
    {
      id: 1,
      title: "MPX Logistics Routinely Conducts Employee Training",
      url: "MPX-Logistics-Rutin-Melakukan-Pelatihan-Karyawan",
      image:
        "/images/artikel/MPX-Logistics-Rutin-Melakukan-Pelatihan-Karyawan.jpg",
      date: "Sunday, October 31, 2021 | 11:12 PM",
      preview:
        "In our opinion, job training or employee training is important and must be done for every employee and company.",
      desc: (
        <>
          <p>
            In our opinion, job training or employee training is important and
            must be done for every employee and company. Job training based on
            Law no. 13 of 2003 concerning Employment are all activities to
            provide, obtain, improve, and develop work competencies,
            productivity, discipline, attitude and work ethic at a certain skill
            and expertise level in accordance with the level and qualifications
            of the position or job.
          </p>
          <p>
            By conducting training, employees can have the knowledge, abilities,
            and skills according to the work they do. The company always needs
            competent personnel in their fields to enhance the company's
            development. Therefore, MPX Logistics International Tbk conducts
            regular employee training and coaching.
          </p>
          <p>
            <h3>
              <strong>
                Training Objectives Or Employee Training Objectives
              </strong>
            </h3>
            <p>
              <strong>1. Knowledge</strong>
              <br />
              MPX Logistics International Tbk employees who are trained or
              fostered by the company are expected to gain sufficient knowledge
              to be able to carry out the tasks that will be given.
            </p>
            <p>
              <strong>2. Skill</strong>
              <br />
              MPX Logistics International Tbk newly trained employees are
              expected to be able and able to perform tasks when placed in a
              predetermined process.
            </p>
            <p>
              <strong>3. Attitude</strong>
              <br />
              After conducting job training, new MPX Logistics International Tbk
              employees are expected to have an interest in and awareness of the
              work they will be doing.
            </p>
          </p>
          <p>
            The objectives to be achieved from the employee training program are
            basically to support the smooth operation and productivity of the
            company.
          </p>
          <p>
            <h3>
              <strong>Benefits of Training and Job Training</strong>
            </h3>
            <p>
              Good job training will bring benefits to employees and the
              company. For MPX Logistics International Tbk, there are many
              benefits derived from employee training. The following is a
              summary of the benefits of the training we have conducted,
              including:
              <br />
              <ol>
                <li>Have a skilled and skilled workforce.</li>
                <li>Increase work productivity.</li>
                <li>Improving the quality of work.</li>
                <li>Tasks and work can run smoothly anytime and anywhere.</li>
                <li>Increase the confidence of our employees.</li>
                <li>Reducing the time spent studying.</li>
                <li>
                  Understand the work and work culture at MPX Logistics
                  International.
                </li>
                <li>
                  Increase the knowledge and skills in their respective fields
                  of our employees.
                </li>
              </ol>
            </p>
          </p>
        </>
      ),
    },
  ],
  id: [
    {
      id: 19,
      title: "MPXL Berhasil Membalikkan Kinerja, Laba Bersih Tumbuh Menjadi Rp4,11 Miliar",
      url: "mpxl-berhasil-membalikkan-kinerja-laba-bersih-tumbuh-menjadi-rp411-miliar",
      image: "/images/artikel/674040454.webp",
      date: "Senin, 10 Agustus 2026 / 11:59 WIB",
      preview:
        "PT MPX Logistics International Tbk (MPXL) mencatatkan kinerja positif pada Semester I 2026 dengan pertumbuhan pendapatan dan berbalik mencetak laba bersih.",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID - Jakarta, Juli 2026</strong> PT MPX
            Logistics International Tbk ("MPXL" atau "Perseroan"), perusahaan
            penyedia jasa logistik dan transportasi terintegrasi, berhasil
            membukukan kinerja yang positif pada Semester I 2026. Perseroan
            mencatatkan pertumbuhan pendapatan sebesar 28,8% dibandingkan
            periode yang sama tahun sebelumnya, sekaligus berhasil membalikkan
            posisi rugi menjadi laba bersih.
          </p>
          <p>
            Pada Semester I 2026, Perseroan membukukan pendapatan sebesar
            Rp73,12 miliar, meningkat dari Rp56,77 miliar pada Semester I 2025.
            Pertumbuhan tersebut terutama didorong oleh meningkatnya aktivitas
            pada segmen jasa ekspedisi, yang mencatatkan pendapatan sebesar
            Rp50,98 miliar, meningkat sekitar 54,5% dibandingkan periode yang
            sama tahun sebelumnya.
          </p>
          <p>
            Seiring dengan meningkatnya pendapatan, Perseroan juga berhasil
            meningkatkan efisiensi operasional. Laba kotor meningkat signifikan
            sebesar 96,5% menjadi Rp15,09 miliar, dibandingkan Rp7,68 miliar
            pada Semester I 2025. Margin laba kotor (Gross Profit Margin)
            turut meningkat dari 13,5% menjadi 20,6%, mencerminkan
            pengendalian biaya pokok pendapatan yang semakin efektif.
          </p>
          <p>
            Kinerja operasional yang lebih efisien juga tercermin dari EBITDA
            yang meningkat 101,3% menjadi Rp16,44 miliar, dengan EBITDA Margin
            naik dari 14,3 % menjadi 22,5%. Hal ini menunjukkan bahwa kualitas
            laba Perseroan semakin baik dan berasal dari aktivitas usaha utama.
          </p>
          <p>
            Perseroan juga berhasil menjaga disiplin dalam pengelolaan biaya.
            Beban umum dan administrasi relatif terkendali, sementara beban
            keuangan turun menjadi Rp4,17 miliar, seiring dengan upaya
            optimalisasi struktur pembiayaan dan pengelolaan kewajiban.
          </p>
          <p>
            Berkat pertumbuhan pendapatan dan peningkatan efisiensi tersebut,
            MPXL berhasil membukukan laba sebelum pajak sebesar Rp4,69 miliar,
            berbalik dari rugi sebelum pajak sebesar Rp3,00 miliar pada
            Semester I 2025. Setelah memperhitungkan pajak penghasilan,
            Perseroan mencatatkan laba bersih sebesar Rp4,11 miliar, meningkat
            sebesar 217,2% dibandingkan posisi rugi bersih sebesar Rp3,50
            miliar pada periode yang sama tahun sebelumnya.
          </p>
          <p>
            Selain mencatatkan perbaikan profitabilitas, Perseroan juga terus
            memperkuat fundamental keuangannya. Total liabilitas mengalami
            penurunan dibandingkan akhir tahun 2025, sementara ekuitas
            meningkat sebagai dampak positif dari laba yang dihasilkan selama
            Semester I 2026. Struktur permodalan yang semakin sehat diharapkan
            dapat mendukung pengembangan usaha secara berkelanjutan.
          </p>
          <p>
            Direksi Perseroan menyampaikan bahwa capaian Semester I 2026
            merupakan hasil dari fokus Perseroan dalam meningkatkan utilisasi
            armada, memperkuat layanan logistik, melakukan efisiensi biaya
            operasional, serta menjaga disiplin pengelolaan keuangan.
          </p>
          <p>
            Ke depan, MPXL akan melanjutkan strategi pertumbuhan melalui
            penguatan bisnis logistik nasional, peningkatan kontribusi jasa
            ekspedisi, pengembangan bisnis rental alat berat, serta memperluas
            portofolio usaha melalui perdagangan batubara dan layanan angkutan
            laut menggunakan kapal tongkang. Langkah tersebut diharapkan dapat
            menciptakan sumber pendapatan yang lebih beragam sekaligus
            memperkuat posisi Perseroan sebagai penyedia layanan logistik
            terintegrasi di Indonesia.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://pressrelease.kontan.co.id/news/mpxl-berhasil-membalikkan-kinerja-laba-bersih-tumbuh-menjadi-rp411-miliar"
                target="_blank"
                rel="noreferrer"
              >
                https://pressrelease.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id:18,
      title:"Diversifikasi bisnis, MPX Logistics (MPXL) dirikan anak usaha baru",
      url:"diversifikasi-bisnis-mpx-logistics-mpxl-dirikan-anak-usaha-baru",
      image:"/images/artikel/1374075960p.jpg",
      date:"Kamis, 22 Januari 2026 / 14:43 WIB",
      preview:"Diversifikasi bisnis, MPX Logistics (MPXL) dirikan anak usaha baru",
      desc:(
        <>
        <p>
        <strong>KONTAN.CO.ID - JAKARTA.</strong>PT MPX Logistics International Tbk (MPXL) mengumumkan pendirian entitas usaha baru yakni PT Tambang Raya Sejahtera.
        </p>

        <p>
            Direktur sekaligus Corporate Secretary PT MPX Logistics International Tbk (MPXL) James S. Chandra
            mengatakan anak usaha ini nantinya akan menjalankan usaha dalam bidang perdagangan besar, meliputi
            perdagangan besar bahan bakar padat, cair dan gas, serta produk yang berhubungan dengan hal tersebut (KBLI Nomor 46610),
            perdagangan besar logam dan bijih logam (KBLI Nomor 46620), serta perdagangan besar mineral bukan Logam (KBLI Nomor 46641).
        </p>
        <p>
            Struktur permodalan dan pemegang saham PT Tambang Raya Sejahtera terdiri dari modal dasar senilai Rp 10 miliar,
            serta modal ditempat dan disetor mencapai Rp 5 miliar. Dari situ, MPXL mengempit Rp 4,97 miliar atau setara 99,5% dan James S. Chandra sebesar Rp 25 juta (0,5%).
        </p>
        <p>
          "Pendirian entitas anak merupakan bentuk penunjang dari kegiatan usaha perusahaan guna mengembangkan diversifikasi bisnis MPXL
          yang diharapkan dapat memberikan pendapatan usaha dan ekspansi grup MPXL," tulis James dalam keterbukaan informasi, Kamis (22/1/2026).
        </p>
        <p>
          Dalam pemberitaan Kontan sebelumnya, MPXL optimistis bisa cetak kenaikan pendapatan minimal 50% dan memperbaiki perolehan laba pada tahun 2026.
        </p>
        <p>
          Direktur Utama MPX Logistics International Wijaya Candera mengungkapkan bahwa MPXL bakal mengoptimalkan strategi diversifikasi bisnis, termasuk dengan pengembangan angkutan komoditas.
        </p>
        <p>
          Selain menggarap bisnis pengangkutan material untuk kontruksi dan infrastruktur, MPXL juga akan mengangkut komoditas Crude Palm Oil (CPO).
         </p>
        <p>
          MPXL juga menggelar ekspansi pada segmen bisnis penjualan (trading). Tak hanya material semen curah dan fly ash,
          MPXL juga bakal menjajal bisnis penjualan batu split dan trading batubara.
        </p>
        <p>
          Wijaya optimistis pengangkutan CPO dan trading batubara bakal mengungkit pendapatan MPXL pada tahun depan.
        </p>
        <p>
          "Target kami untuk 2026, mencapai minimal 50% pertumbuhan 2025 dari sisi pendapatan.
           Kalau dari sisi laba kami targetkan lebih baik dari 2025. Strateginya diversifikasi bisnis,
           dari trucking semen ke CPO dan trading batubara di pasar domestik," kata Wijaya saat dihubungi Kontan.co.id, Jumat (26/12/2025).
        </p>
        <p>
          Sembari menyongsong tahun 2026, fokus MPXL pada akhir tahun 2025 adalah memperbaiki kinerja bisnis dan keuangannya.
           Sampai dengan kuartal III-2025, performa MPXL sedang lunglai. Pendapatan MPXL merosot dan berbalik menanggung kerugian.
        </p>
       <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://investasi.kontan.co.id/news/diversifikasi-bisnis-mpx-logistics-mpxl-dirikan-anak-usaha-baru"
                target="_blank"
                rel="noreferrer"
              >
              https://investasi.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      )

    },
    {
      id:17,
      title:"MPX Logistics (MPXL) Dirikan Modal Usaha Baru Dibidang Angkutan Laut",
      url:"mpx-logistics-mpxl-dirikan-modal-usaha-baru-dibidang-angkutan-laut",
      image:"/images/artikel/1374075960p.jpg",
      date:"Rabu, 05 Februari 2025 / 18:35 WIB",
      preview:"MPX Logistics (MPXL) Dirikan Modal Usaha Baru Dibidang Angkutan Laut",
      desc:(
        <>
        <p>
        <strong>KONTAN.CO.ID - JAKARTA.</strong> Emiten transportasi dan logistik, PT MPX Logistics International Tbk (MPXL) mendirikan sebuah anak perusahaan bernama, PT MPX Maritim Nusantara.
        </p>

        <p>
        Sekretaris Perusahaan MPX Logistics International James S. Chandra menjelaskan MPX Maritim Nusantara akan fokus dalam kegiatan usaha di angkutan laut dalam negeri.
        </p>
        <p>
        Perusahaan yang berkedudukan di Jakarta Utara ini, fokus dalam angkutan laut untuk barang umum dan barang khusus. MPX Maritim Nusantara juga melaksanakan perusahaan holding.
        </p>
        <p>
        MPX Maritim Nusantara memiliki modal disetor sebesar 100 saham atau dengan nominal Rp 10 miliar. Di mana, MPXL memiliki 49.999 saham MPX Maritim Nusantara.
        </p>
        <p>
        Sementara sisanya, satu lembar saham dimiliki oleh Wijaya Candera. Adapun nominal kepemilikan WIjaya Candera di MPX Maritim Nusantara sebesar Rp 100.000.

        </p>
        <p>
        “Pendirian MPX Maritim Nusantara akan memberikan dampak dan kontribusi positif di masa mendatang bagi MPXL,” jelas James dalam keterbukaan informasi, Rabu (5/2).
        </p>
        <p>
        James mengatakan sebagai entitas anak, MPX Maritim Nusantara akan memperluas jaringan usaha sebagai bagian dari rencana strategis pengembangan usaha MPXL.
         </p>
        <p>
        Per September 2024, MPXL membukukan pendapatan sebesar Rp 147,97 miliar. Ini meningkat 51,34% secara tahunan atau Year on Year (YoY) menjadi Rp 97,77 miliar per September 2023.
         </p>
        <p>
        Dari sisi bottom line, laba yang dapat diatribusikan kepada pemilik entitas induk MPXL mencapai Rp 12,11 miliar hingga kuartal III-2024. Ini meningkat 57,79% YoY dari Rp 7,67 miliar.
       </p>
       <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://investasi.kontan.co.id/news/mpx-logistics-mpxl-dirikan-modal-usaha-baru-dibidang-angkutan-laut"
                target="_blank"
                rel="noreferrer"
              >
              https://investasi.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      )

    },
    {
      id: 16,
      title:"Laba MPX Logistics International (MPXL) Tumbuh 69,2% di Semester I-2024",
      url:"laba-mpx-logistics-international-mpxl-tumbuh-692-di-semester-i-2024",
      image:"/images/artikel/307815069p.jpg",
      date:"Jumat, 26 Juli 2024 |  05:13 PM WIB",
      preview:"PT MPX Logistics International Tbk (MPXL) mencatatkan kinerja positif hingga semester I 2024.",
      desc: (
        <>

          <p>
          <strong>  KONTAN.CO.ID - JAKARTA.</strong>  PT MPX Logistics International Tbk (MPXL) mencatatkan kinerja positif hingga semester I 2024.
          </p>
          <p>
          Direktur Utama MPX Logistics International, Wijaya Candera mengatakan bahwa perseroan membukukan pendapatan sebesar Rp 97,06 miliar pada semester I 2024. Hasil itu meningkat 53% dibandingkan dengan periode yang sama tahun lalu sebesar Rp 63,5 miliar.

          </p>
          <p>

          Beriringan, MPXL membukukan laba bersih sebesar Rp 7,3 miliar atau tumbuh 69,2% secara tahunan. Pada semester I 2023, MPXL membukukan laba bersih sebesar Rp 4,3 miiliar.

          </p>
          <p>

          Dus, perseroan mencatatkan pertumbuhan EBITDA sebesar 44,6% YoY menjadi Rp 16,3 miliar. "Pertumbuhan ini dipengaruhi oleh peningkatan volume angkutan dan efisiensi biaya," ujarnya dalam keterangan resmi, Jumat (26/7).

          </p>
          <p>
          Wijaya menegaskan bahwa perseroan akan terus melanjutkan berbagai inisiatif untuk menjaga kinerja positif MPXL. Salah satunya, ekspansi dan peremajaan armada, yang penting untuk meningkatkan kenyamanan pelanggan dan menjaga operasional kendaraan pada tingkat utilisasi yang tinggi.

          </p>
          <p>
          Wijaya menuturkan, saat ini perseroan juga telah membeli lahan seluas 1.250 m² yang berlokasi di daerah Gunung Putri, Bogor. Adapun peruntukannya akan digunakan sebagai bengkel dan workshop perseroan.

          </p>
          <p>

          "Ini akan membuat perseroan menjadi lebih efisien dan efektif dalam mengelola operasional kendaraan dalam masa yang akan datang," paparnya.

          </p>
          <p>
          Selain itu, sebanyak 20 unit armada truk baru yang tiba bulan ini telah sebagian besar dialokasikan ke wilayah Kalimantan Timur. Ia menyebutkan pihaknya sangat mendukung pembangunan Ibu Kota Nusantara (IKN) dengan keluarnya Peraturan Presiden (Perpres) Nomor 75 Tahun 2024 tentang Percepatan Pembangunan IKN.

          </p>

          <p>

          "Hal ini menjadi sinyal positif bagi kami untuk meningkatkan volume angkutan di semester 2 nantinya," lanjut Wijaya.

          </p>
          <p>
          Adapun kapasitas angkutan semen curah dan material tambang hingga semester 1 tahun 2024 mengalami kenaikan sebesar 35% dibandingkan periode yang sama tahun lalu. Hal ini membuat perseroan optimistis dapat mencapai target tahun 2024.

          </p>

          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://investasi.kontan.co.id/news/laba-mpx-logistics-international-mpxl-tumbuh-692-di-semester-i-2024"
                target="_blank"
                rel="noreferrer"
              >
              https://investasi.kontan.co.id/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 15,
      title:"Mantap! Pendapatan MPX Logistics Tumbuh 53% di Semester I-2024",
      url:"mantap-pendapatan-mpx-logistics-tumbuh-53-di-semester-i-2024",
      image:"/images/artikel/pt-mpx-logistics-international-tbk-mpxl_169.jpeg",
      date:"Jumat, 26 Juli 2024 |  08:30  WIB",
      preview:"PT MPX Logistics International Tbk (MPXL) mencatatkan pendapatan sebesar Rp 97,06 miliar di Semester I-2024.",
      desc: (
        <>
          <p>
          <strong>Jakarta, CNBC Indonesia</strong> - PT MPX Logistics International Tbk (MPXL) mencatatkan pendapatan sebesar Rp 97,06 miliar di Semester I-2024. Jumlah ini meningkat 53% jika dibandingkan dengan periode yang sama tahun lalu sebesar Rp 63,50 miliar.

          </p>
          <p>
          "Peningkatan pendapatan ini berujung pada kenaikan laba bersih yang dapat diatribusikan kepada pemilik entitas induk perseroan sebesar 69,2%, yaitu menjadi Rp 7,35 miliar," jelas Direktur Utama MPXL, Wijaya Candera, dalam keterangan resminya dikutip Kamis (25/7/2024).

          </p>

          <p>
          Sebagai hasilnya, MPXL mencatatkan pertumbuhan EBITDA sebesar 44,6% yoy, menjadi Rp 16,30 miliar dibandingkan periode yang sama tahun sebelumnya. Pertumbuhan ini dipengaruhi oleh peningkatan volume angkutan dan efisiensi biaya.

            </p>

          <p>

          Untuk mempermudah percepatan perbaikan unit armada truk yang melayani customer di Provinsi Jawa Barat dan Jawa Tengah, manajemen MPXL membeli lahan seluas 1.250 m² di daerah Gunung Putri, Bogor. Lahan tersebut akan digunakan sebagai bengkel dan workshop perseroan.

          </p>
          <p>
          Menurut Wijaya ini akan membuat perseroan menjadi lebih efisien dan efektif dalam mengelola operasional kendaraan di masa mendatang.

          </p>

          <p>
          Tak hanya itu, MPXL juga mengalokasikan sebanyak 20 unit armada truk baru ke wilayah Kalimantan Timur untuk meningkatkan volume angkutan di semester II-2024.

          </p>
          <p>
          "Kami mendukung pembangunan Ibu Kota Nusantara (IKN) dengan keluarnya Peraturan Presiden (Perpres) Nomor 75 Tahun 2024 tentang Percepatan Pembangunan IKN. Hal ini menjadi sinyal positif bagi kami untuk meningkatkan volume angkutan di semester 2 nantinya," lanjut Wijaya.

          </p>
          <p>

          Wijaya menegaskan bahwa perseroan akan terus melanjutkan berbagai inisiatif untuk menjaga kinerja positif MPXL, termasuk ekspansi dan peremajaan armada. Hal ini dilakukan untuk meningkatkan kenyamanan pelanggan dan menjaga operasional kendaraan pada tingkat utilisasi yang tinggi.

          </p>
          <p>
          Dia juga menyebut bahwa kapasitas angkutan semen curah dan material tambang mengalami kenaikan sebesar 35% hingga semester I-2024 dibandingkan periode yang sama tahun lalu. Hal ini membuat perseroan optimis dapat mencapai target tahun 2024.

          </p>
          <p>
           "Pencapaian gemilang ini diraih berkat kemampuan perseroan menjaga loyalitas dan permintaan pelanggan melalui berbagai langkah strategis yang mengacu pada kebutuhan pelanggan. Kinerja positif ini juga didorong oleh perluasan aset yang cermat, peningkatan utilisasi armada, dan fokus pada layanan unggul," pungkas dia.
           </p>

          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.cnbcindonesia.com/market/20240725162700-17-557647/mantap-pendapatan-mpx-logistics-tumbuh-53-di-semester-i-2024"
                target="_blank"
                rel="noreferrer"
              >
              https://www.cnbcindonesia.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 14,
      title:"Laba Bersih MPXL Melonjak 123,6 Persen, Ditopang Jasa Angkut Material ke IKN",
      url:"laba-bersih-mpxl-melonjak-123-6-persen-ditopang-jasa-angkut-material-ke-ikn",
      image:"/images/artikel/6540b313121ae.jpg",
      date:"Rabu, 7 Mei 2024 |  10:46 WIB",
      preview:" PT MPX Logistics International Tbk (MPXL) mencatatkan laba bersih konsolidasi sebesar Rp 4,08 miliar pada kuartal I 2024. Angka ini tumbuh 123,6 persen dari laba bersih konsolidasi kuartal I 2023 sebesar Rp 1,82 miliar.",
      desc: (
        <>
          <p>
            <strong> JAKARTA, KOMPAS.com  </strong>
            - PT MPX Logistics International Tbk (MPXL) mencatatkan laba bersih konsolidasi sebesar Rp 4,08 miliar pada kuartal I 2024. Angka ini tumbuh 123,6 persen dari laba bersih konsolidasi kuartal I 2023 sebesar Rp 1,82 miliar.
          </p>
          <p>
            Kenaikan laba bersih tersebut sejalan dengan meningkatnya pendapatan material dan jasa angkut yang berlokasi di proyek Ibu Kota Nusantara (IKN).
          </p>
          <p>
            Selain itu pendapatan perseroan ditopang oleh meningkatnya pengangkutan limbah batubara PLTU (FaBa).
          </p>
          <p>
            Direktur Utama MPXL Wijaya Candera mengatakan, sepanjang kuartal I 2024 MPXL mencatatkan pendapatan bersih konsolidasi mengalami kenaikan sebesar 60,24 persen secara tahunan atau year on year (yoy) menjadi Rp 45,42 miliar pada kuartal I 2024 dibandingan sebelumnya sebesar Rp 28,3 miliar pada kuartal I 2023.
          </p>
          <p>
            Pertumbuhan ini ditopang kenaikan dari pendapatan jasa angkut sebesar 149,21 persen menjadi Rp 24,8 Miliar pada kuartal I 2024 dibandingan sebelumnya sebesar Rp 9,9 miliar pada kuartal I 2023.
          </p>
          <p>
            Selain itu, pendapatan diperoleh dari pertumbuhan penjualan material sebesar 12,1 persen menjadi Rp 20,6 miliar pada kuartal I 2024 dibandingan sebelumnya sebesar Rp 18, miliar pada kuartal I 2023.
          </p>
          <p>
            Wijaya menambahkan, ke depannya, MPXL masih akan berfokus pada segmen perdagangan Material dan jasa angkut yang menjadi core business perseroan, dengan terus melakukan pengembangan transportasi logistik lainnya seperti fly ash, bottom ash, clinker, lime stone, dan coal.
          </p>
          <p>
            Pada tahun ini perseroan telah menambah 50 unit armada truk tronton baru untuk memenuhi kenaikan permintaan angkutan dari kontrak bisnis jangka panjang perseroan.
          </p>
          <p>
           Wijaya menjelaskan armada baru tersebut akan diproyeksikan untuk meningkatkan pendapatan sebesar Rp 50 milliar.
          </p>
          <p>
            "Sehingga target perusahaan sebesar Rp 222 milliar di tahun 2024 dapat tercapai," kata dia dalam keterangan tertulis, Selasa (7/5/2024).
          </p>
          <p>
            Tidak hanya untuk meningkatkan pendapatan, tetapi juga akan memberikan kontribusi positif terhadap pertumbuhan ekonomi di sektor angkutan dan logistik.
          </p>
          <p>
            Perseroan melalui anak usahanya, yaitu MPX Indorental Gemilang juga telah menjalin kemitraan strategis dengan kontrak selama 5 tahun kedepan dengan perusahaan Power China dalam menyediakan alat berat untuk dioperasikan di dalam area tambang batu andesit yang berlokasi di Palu, Sulawesi Tengah.
          </p>
          <p>
            "Selain itu, perseroan juga menjajaki jasa angkut batu andesit dari pertambangan tersebut dengan kapal tongkang untuk dikirim ke IKN," ujar Wijaya.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://money.kompas.com/read/2024/05/07/161300726/laba-bersih-mpxl-melonjak-123-6-persen-ditopang-jasa-angkut-material-ke-ikn"
                target="_blank"
                rel="noreferrer"
              >
              https://Kompas.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 13,
      title:"Laba MPX Logistics (MPXL) Meroket 123,6%, Ini Penopangnya",
      url:"laba-mpx-logistics-mpxl-meroket-1236-ini-penopangnya",
      image:"/images/artikel/1704330991-1600x970.webp",
      date:"Rabu, 7 Mei 2024 | 10:40 WIB",
      preview:"PT MPX Logistics International Tbk (MPXL) mencatatkan laba bersih Rp 4,08 miliar pada kuartal I-2024. Angka ini tumbuh 123,6% dibandingkan periode yang sama pada tahun lalu sebesar Rp 1,82 miliar.",
      desc: (
        <>
          <p>
            <strong>  JAKARTA, investor.id   </strong>
            - PT MPX Logistics International Tbk (MPXL) mencatatkan laba bersih Rp 4,08 miliar pada kuartal I-2024. Angka ini tumbuh 123,6% dibandingkan periode yang sama pada tahun lalu sebesar Rp 1,82 miliar.
          </p>
          <p>
          Direktur Utama MPX Logistics International (MPXL) Wijaya Candera mengatakan, kenaikan laba bersih tersebut sejalan dengan meningkatnya pendapatan material dan jasa angkut yang berlokasi di proyek Ibu Kota Nusantara. “Selain itu pendapatan perseroan ditopang oleh meningkatnya pengangkutan limbah batu bara PLTU (FaBa),” ungkap Wijaya dalam keterangan pers, Selasa (7/5/2024).
          </p>
          <p>
            Sepanjang kuartal I-2024, lanjut Wijaya, MPXL mencatatkan Pendapatan bersih konsolidasi mengalami kenaikan sebesar 60,24%YoY menjadi Rp 45,42 miliar pada kuartal 1-2024 dari  Rp 28,3 miliar pada kuartal 1-2023. Pertumbuhan ini dikarenakan kenaikan dari Pendapatan jasa angkut sebesar 149,21% menjadi Rp 24,8 miliar pada kuartal 1-2024 dibandingkan periode yang sama pada tahun sebelumnya sebesar Rp 9,9 miliar.
          </p>
          <p>
          “Serta, adanya pertumbuhan penjualan material sebesar 12,1% menjadi Rp 20,6 miliar kuartal 1-2024 dibandingkan periode yang sama pada tahun sebelumnya sebesar Rp 18 miliar,” jelas Wijaya.
          </p>
          <p>
          Wijaya menambahkan, ke depannya, MPXL masih akan berfokus pada segmen perdagangan Material dan jasa angkut yang menjadi core business Perseroan, dengan terus melakukan pengembangan transportasi logistik lainnya seperti fly ash, bottom ash, clinker, lime stone, dan coal. Dalam tahun ini perseroan telah menambah 50 unit armada truk tronton baru untuk memenuhi kenaikan permintaan angkutan dari kontrak bisnis jangka panjang perseroan.
          </p>
          <p>
          “Armada baru tersebut akan diproyeksikan untuk meningkatkan pendapatan sebesar Rp 50 miliar. Sehingga target perusahaan sebesar Rp 222 miliar di tahun 2024 dapat tercapai. Tidak hanya untuk meningkatkan pendapatan, tetapi juga akan memberikan kontribusi positif terhadap pertumbuhan ekonomi di sektor angkutan dan logistik,” paparnya.
          </p>
          <p>
          Lebih lanjut Wijaya mengatakan, perseroan melalui anak usahanya MPX Indorental Gemilang juga telah menjalin kemitraan strategis dengan kontrak selama 5 tahun kedepan dengan perusahaan Power China dalam menyediakan alat berat untuk dioperasikan di dalam area tambang batu andesit yang berlokasi di Palu, Sulawesi Tengah.
          </p>
          <p>
          “Selain itu, perseroan juga menjajaki jasa angkut batu Andesit dari pertambangan tersebut dengan kapal tongkang untuk di kirim ke Ibu Kota Nusantara, Kalimantan Timur,” tutupnya.
          </p>

          <TradingViewWidget />

          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://investor.id/market/361014/laba-mpx-logistics-mpxl-meroket-1236-ini-penopangnya"
                target="_blank"
                rel="noreferrer"
              >
              https://investor.id/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 12,
      title:"MPX Logistics (MPXL) Sepakat Bagi Dividen Rp3 Miliar",
      url:"MPX-Logistics-(MPXL)-Sepakat-Bagi-Dividen-Rp3-Miliar",
      image:"/images/artikel/mpx-logistics-mpxl-sepakat-bagi-dividen-rp3-miliar.jpg",
      date:"Rabu, 24 April 2024 |  10:46 WIB",
      preview:"PT MPX Logistics International Tbk (MPXL) sepakat membagikan dividen sebesar Rp3 miliar dalam Rapat Umum Pemegang Saham Tahunan (RUPST), pada Selasa (23/4/2024).",
      desc: (
        <>
          <p>
            <strong>  IDXChannel  </strong>
            PT MPX Logistics International Tbk (MPXL) sepakat membagikan dividen sebesar Rp3 miliar dalam Rapat Umum Pemegang Saham Tahunan (RUPST), pada Selasa (23/4/2024).
          </p>
          <p>
           Adapun sebesar Rp2 miliar telah di bagikan sebagai dividen interim pada 17 November 2023. Sementara itu, sisa dari laba bersih konsollidasian pasca pembagian dividen dan cadangan umum, dicatat sebagai laba ditahan untuk membiayai modal kerja perseroan.
          </p>
          <p>
            “Dividen yang akan dibagikan dalam bentuk dividen tunai kepada para pemegang saham yang namanya tercatat dalam Daftar Pemegang Saham per 6 Mei 2024," ujar Direktur Utama MPXL, Wijaya Candera, dalam keterangan resminya, Rabu (24/4/2024).
          </p>
          <p>
          Wijaya menjelaskan, alokasi penggunaan laba bersih sebagai dividen merupakan wujud komitmen perusahaan yang ingin memberikan nilai tambah bagi para pemegang saham.
          </p>
          <p>
          “Pembagian dividen tersebut sudah mempertimbangkan keuntungan atau saldo laba positif tahun fiskal dan kewajiban perusahaan untuk mengalokasikan dana cadangan sesuai dengan aturan yang berlaku dan kondisi keuangan. Tingkat pertumbuhan bisnis ke depan juga menjadi pertimbangan dalam pembagian dividen," tutur Wijaya.
          </p>
          <p>
          MPXL berhasil mencatatkan pencapaian yang positif di sepanjang 2023 lalu. Pendapatan bersih konsolidasi mengalami kenaikan sebesar 19,9% YoY menjadi Rp140 juta ditopang pencapaian pendapatan dari segmen operasional jasa transportasi dan segmen perdagangan material.
          </p>
          <p>
          "Peningkatan laba bersih ini menunjukkan strategi perusahaan yang efektif dalam mengelola situasi ekonomi hingga berhasil menjaga profitabilitas," ungkap Wijaya.
          </p>
          <p>
          Selain pembagian dividen, RUPST juga memutuskan pengangkatan Budi Chandra yang merupakan Direktur PT BOLDE Indonesia yang merupakan pemegang saham perseroan sebagai komisaris untuk melengkapi jajaran komisaris yang ada.
          </p>
          <p>
              Berikut susunan dewan komisaris terbaru:
          </p>
          <p>
            * Presiden Komisaris: Ye Hun Ki <br/>
            * Komisaris: Budi Chandra <br/>
            * Komisaris Independen: Katherine Judy
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.idxchannel.com/market-news/mpx-logistics-mpxl-sepakat-bagi-dividen-rp3-miliar"
                target="_blank"
                rel="noreferrer"
              >
               https://www.idxchannel.com/
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 11,
      title:"MPX Logistics (MPXL) Raih Kredit dari BCA, Simak Rencananya",
      url:"MPX-Logistics-(MPXL)-Raih-Kredit-dari-BCA,-Simak-Rencananya",
      image:"/images/artikel/pelni-angkutan-barang-1.jpg",
      date:"Senin, 20 November 2023 | 11:07 WIB",
      preview:"PT MPX Logistics International Tbk. (MPXL) mendapatkan fasilitas kredit sebesar Rp40,94 miliar dari PT Bank Central Asia Tbk. (BBCA).",
      desc: (
        <>
          <p>
            <strong> Bisnis.com, </strong>
            JAKARTA - Emiten transportasi dan logistik, PT MPX Logistics International Tbk. (MPXL) mendapatkan fasilitas kredit sebesar Rp40,94 miliar dari PT Bank Central Asia Tbk. (BBCA). Rencananya, pinjaman itu akan digunakan untuk melakukan ekspansi armada truk hingga pembangunan bengkel.
          </p>
          <p>
            Corporate Secretary MPXL Nilam Sari Siregar mengatakan, penandatanganan perjanjian kredit dengan BBCA telah dilaksanakan pada Kamis, 16 November 2023.
          </p>
          <p>
            "Kredit investasi ini akan digunakan untuk pembiayaan pembelian unit armada truk tronton baru, pembangunan garasi dan bengkel perseroan," ujarnya dikutip dari keterbukaan informasi BEI pada Senin, (20/11/2023).
          </p>
          <p>
            Adapun, dampak atas fasilitas kredit yang diterima dari Bank BCA tersebut antara lain yakni pembelian unit baru armada truk tronton untuk proyek Ibu Kota Nusantara (IKN) dan jalan tol.
          </p>
          <p>
           "Revenue atau pendapatan perseroan meningkat sehingga kegiatan usaha perseroan berkembang," pungkas Nilam.
          </p>
          <p>
            Ditinjau kinerja keuangannya, MPXL mencatatkan pendapatan sebesar Rp97,77 miliar per kuartal III/2023, atau naik 13% secara year-on-year (yoy) dibandingkan periode sama 2022 sebesar Rp86,51 miliar.
          </p>
          <p>
            Secara rinci berdasarkan segmen, pendapatan MPXL ditopang dari penjualan material sebesar Rp60,61 miliar, dan jasa ekspedisi sebesar Rp37,15 miliar.
          </p>
          <p>
            Dari sisi bottom line, laba bersih MPXL melompat 54,75% yoy menjadi Rp7,67 miliar per 30 September 2023, dibanding periode sama 2022 sebesar Rp4,96 miliar.
          </p>
          <p>
            Sebagai informasi, MPXL kerap mendapatkan fasilitas kredit dari Bank BCA (BBCA). Sebelumnya pada Oktober 2023 lalu, MPXL juga mendapatkan kredit sebesar Rp25 miliar dari BBCA untuk menambah armada truk.
          </p>
          <p>
            Kala itu, MPXL membeli 23 unit truk bermuatan besar untuk mendongkrak kinerja perseroan. Secara rinci, MPXL memborong truk jenis tronton hi-blow sebanyak 20 unit, dan truk jenis trailer hi-blow sebanyak 3 unit.
          </p>

          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://market.bisnis.com/read/20231120/192/1715963/mpx-logistics-mpxl-raih-kredit-dari-bca-simak-rencananya"
                target="_blank"
                rel="noreferrer"
              >
                https://market.bisnis.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 10,
      title:
        "MPXL Siap Tebar Dividen Rp2 Miliar, Cek Jadwalnya",
      url: "MPXL-Siap-Tebar-Dividen-Rp2-Miliar,-Cek-Jadwalnya",
      image:
        "/images/artikel/MPXL-Siap-Tebar-Dividen-Rp2-Miliar,-Cek-Jadwalnya.jpg",
      date: "Kamis, 19 Oktober 2023 | 10:53 WIB",
      preview:
        "PT MPX Logistics International Tbk (MPXL) berencana membagikan dividen interim tahun buku 2023 sebesar Rp2 miliar.",
      desc: (
        <>
          <p>
            <strong>IDXChannel</strong> - PT MPX Logistics International Tbk (MPXL) berencana membagikan dividen interim
            tahun buku 2023 sebesar Rp2 miliar. Keputusan tersebut telah mendapat persetujuan dari Dewan Komisaris perseroan
            pada 17 Oktober 2023 lalu.
          </p>
          <p>
              “Direksi perseroan telah memutuskan pembagian dividen interim dari hasil laba perseroan untuk tahun buku yang berakhir
              pada tanggal 31 Desember 2023, sebesar Rp1 per saham,” kata Sekretaris Perusahaan MPXL, Nilam Sari Siregar dalam
              keterbukaan informasi, Kamis (19/10/2023).
          </p>
          <p>
              Nilam mengtakan dividen interim akan dibagikan kepada para pemegang saham yang namanya tercatat dalam Daftar
              Pemegang Saham atau recording date perseroan pada 31 Oktober 2023 pukul 16.00 WIB.
          </p>
          <p>
              Berikut jadwal pembagian dividen MPXL:
              <ol>
                <li>Cum Dividen di Pasar Reguler dan Pasar Negosiasi : 27 Oktober 2023 </li>
                <li>Ex Dividen di Pasar Reguler dan Pasar Negosiasi : 30 Oktober 2023  </li>
                <li>Cum Dividen untuk perdagangan di Pasar Tunai : 31 Oktober 2023 </li>
                <li>Ex Dividen untuk perdagangan di Pasar Tunai : 1 November 2023  </li>
                <li>Recording Date yang berhak atas Dividen : 31 Oktober 2023 pukul 16.00 WIB </li>
                <li>Pembayaran Dividen : 17 November 2023 </li>
              </ol>
          </p>
         <p>
         Adapun per Juni 2023, MPXL mengantongi laba tahun berjalan sebesar Rp4,34 miliar, naik dari periode yang sama tahun sebelumnya yang sebesar Rp3,40 miliar.
          </p>
         <p>
            Sementara itu, pendapatan perseroan tercatat sebesar Rp63,50 miliar, naik dari sebelumnya sebesar Rp51,38 miliar.
            Secara rinci, penjualan material tercatat sebesar Rp40,20 miliar, serta pendapatan dari jasa ekspedisi tercatat sebesar Rp23,30 miliar.
          </p>

          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.idxchannel.com/market-news/mpxl-siap-tebar-dividen-rp2-miliar-cek-jadwalnya/all"
                target="_blank"
                rel="noreferrer"
              >
                https://www.idxchannel.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 9,
      title:
        "Ikut Bangun IKN, MPX Logistics (MPXL) Mulai Kirim Armada Pengangkut Material ",
      url: "Ikut-Bangun-IKN,-MPX-Logistics-MPXL-Mulai-Kirim-Armada-Pengangkut-Material",
      image:
        "/images/artikel/Ikut-Bangun-IKN,-MPX-Logistics-MPXL-Mulai-Kirim-Armada-Pengangkut-Material.jpg",
      date: "Senin, 4 September 2023 | 16:03 WIB",
      preview:
        "PT MPX Logistics International Tbk (MPXL) mulai mengirimkan sejumlah unit armadanya ke kawasan IKN Nusantara, di Kalimantan Timur.",
      desc: (
        <>
          <p>
            <strong>IDXChannel</strong> - PT MPX Logistics International Tbk
            (MPXL) mulai mengirimkan sejumlah unit armadanya ke kawasan IKN
            Nusantara, di Kalimantan Timur.
          </p>
          <p>
            MPXL terlibat pada jasa angkut material dalam pembangunan kawasan
            pemerintahan ibu kota baru tersebut. Dalam tahap awal, MPXL mengirim
            sebanyak 5 unit Armada Tronton jenis Hi-Blow untuk project
            pengangkutan semen curah.
          </p>
          <p>
            Total dari armada yang akan menjadi salah satu ujung tombak
            pembangunan IKN itu berjumlah 50 unit kendaraan truk. Total
            kapasitas (kemampuan angkut) 50 armada truk tersebut berkisar 36
            ribu ton semen curah setiap bulan.
          </p>
          <p>
            Ini akan membuat material untuk pembangunan IKN selalu tersedia
            sehingga proses pengecoran BUMN Karya maupun Swasta menjadi lancar.
          </p>
          <p>
            Perseroan saat ini bekerja sama dengan Cemindo Gemilang Tbk (CMNT)
            untuk mengirimkan material semen curah ke lokasi proyek IKN.
          </p>
          <p>
            Direktur MPXL Wijaya Candera mengatakan, perseroan dalam tahap
            pembicaraan untuk jadwal pengiriman armada truk setelah selesai
            mengikuti Tender jasa angkutan material semen curah untuk proyek IKN
            yang diadakan PT Indocement Tunggal Prakarsa Tbk (INTP).
          </p>
          <p>
            "Proyek pengangkutan material IKN ini akan berdampak meningkatkan
            sisi pendapatan dari jasa angkut perseroan dari tahun ke tahun
            karena ini proyek pembangunan jangka panjang. Pembangunan IKN
            merupakan sejarah baru untuk mewujudkan peradaban baru. Kami ingin
            MPXL bisa ikut berkontribusi di dalam pembangunan sejarah baru
            Indonesia ini," ucap Wijaya dalam keterangan resmi, Kamis
            (31/8/2023).
          </p>
          <p>
            Untuk diketahui, PT MPX Logistics International Tbk mendapatkan
            kontrak kerja sama dengan sejumlah perusahaan untuk jasa
            pengangkutan material. Di antaranya PT Conch Cement Indonesia, BUT
            Synohidro Corporation, PT Indocement Tunggal Prakarsa Tbk.
          </p>
          <p>
            MPXL resmi mencatatkan sahamnya di Bursa Efek Indonesia (BEI),
            Selasa (9/5/2023). Melalui penawaran umum perdana saham atau initial
            public offering (IPO), perseroan berpotensi mengantongi dana segar
            sebesar Rp43,20 miliar.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.idxchannel.com/market-news/ikut-bangun-ikn-mpx-logistics-mpxl-mulai-kirim-armada-pengangkut-material"
                target="_blank"
                rel="noreferrer"
              >
                https://www.idxchannel.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 8,
      title:
        "Ekspansi MPX Logistics (MPXL) Mengangkut Cuan dari Material Konstruksi",
      url: "Ekspansi-MPX-Logistics-(MPXL)-Mengangkut-Cuan-dari-Material-Konstruksi",
      image:
        "/images/artikel/Ekspansi-MPX-Logistics-(MPXL)-Mengangkut-Cuan-dari-Material-Konstruksi.jpg",
      date: "Jumat, 11 Agustus 2023 | 09:26 WIB",
      preview:
        "PT MPX Logistics International Tbk (MPXL) menggali potensi cuan dari jasa transportasi material konstruksi. Punya prospek yang seksi, MPXL sedang menggeber ekspansi di tengah roda pembangunan yang terus berjalan.",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID - JAKARTA. </strong> PT MPX Logistics
            International Tbk (MPXL) menggali potensi cuan dari jasa
            transportasi material konstruksi. Punya prospek yang seksi, MPXL
            sedang menggeber ekspansi di tengah roda pembangunan yang terus
            berjalan.
          </p>
          <p>
            Emiten yang melantai di Bursa Efek Indonesia (BEI) pada 9 Mei 2023
            ini memiliki spesialisasi pada layanan transportasi di sektor
            konstruksi. Selain pengangkutan, MPXL melakukan aktivitas
            perdagangan material, khususnya semen serta Fly Ash dan Bottom Ash
            (FABA).
          </p>
          <p>
            MPXL terdaftar di Kementerian Lingkungan Hidup sebagai salah satu
            pengangkut limbah FABA terbesar. Mayoritas pelanggan MPXL merupakan
            perusahaan semen dan Pembangkit Listrik Tenaga Uap (PLTU).
          </p>
          <p>
            Selepas Initial Public Offering (IPO), MPXL gencar mengincar kontrak
            dan pelanggan baru. Beberapa waktu lalu, MPXL menjalin kerja sama
            dengan Sinohydro–NEM Consortium untuk memasok semen dalam
            pembangunan Smelter Amman Mineral di Sumbawa, Nusa Tenggara Barat.
          </p>
          <p>
            MPXL sudah mulai mengangkut semen ke Sumbawa pada Juli ini, dengan
            volume pengangkutan perdana mencapai 2.300 ton. MPXL akan melakukan
            beberapa kali pengiriman ke Sumbawa secara bertahap selama 18 bulan
            ke depan.
          </p>
          <p>
            MPXL juga telah menandatangani kontrak pengangkutan FABA PLTU
            sebanyak 660.000 ton dari perusahaan semen asal China yang
            berinvestasi di Indonesia, yakni PT Conch Cement Indonesia.
            Perolehan kontrak tersebut menjadi modal kepercayaan diri MPXL untuk
            mendongkrak kinerja di tahun ini.
          </p>
          <p>
            Apalagi, kinerja semester I-2023 MPXL terbilang cemerlang. MPXL
            mengantongi pendapatan sebesar Rp 63,50 miliar hingga Juni 2023,
            tumbuh 23,58% dibandingkan periode yang sama tahun lalu.
          </p>
          <p>
            MPXL membukukan laba tahun berjalan sebesar Rp 4,34 miliar,
            meningkat 27,64% dari periode enam bulan pertama tahun 2022.
            Direktur Utama MPXL, Wijaya Candera, menyampaikan adanya
            kontrak-kontrak baru dengan nilai yang cukup besar menjadi pendorong
            utamanya.
          </p>
          <p>
            "Juga karena peningkatan permintaan jasa angkutan customers
            existing. Selain itu, karena peningkatan produktivitas angkutan
            kami," kata Wijaya kepada Kontan.co.id, Jumat (28/7).
          </p>
          <p>
            Wijaya memproyeksikan pendapatan MPXL sepanjang tahun 2023 bisa
            mencapai Rp 155 miliar atau melonjak 34% secara tahunan. Sedangkan
            estimasi pertumbuhan laba bersih MPXL mencapai 103% menjadi Rp 12,2
            miliar.
          </p>
          <p>
            Guna meraih target pertumbuhan yang berkelanjutan, MPXL pun
            menyiapkan sejumlah agenda ekspansi. Antara lain dengan melirik
            peluang bisnis dari proyek Ibu Kota Nusantara (IKN) di Kalimantan
            Timur.
          </p>
          <p>
            "Kami sudah melakukan survei ke IKN dan sudah mulai mempersiapkan
            unit kendaraan untuk beroperasi dengan mitra kami untuk proyek IKN,"
            ungkap Wijaya.
          </p>
          <p>
            Strategi lainnya, MPXL sedang mempersiapkan divisi baru untuk
            ekspansi ke segmen alat berat. "Kami juga sedang melakukan
            penjajakan dengan mitra untuk mendapatkan proyek penyewaan alat
            berat dan mulai beroperasi di kuartal keempat 2023," imbuh Wijaya.
          </p>
          <p>
            Guna menopang strategi ini, MPXL menggenjot belanja modal (capex).
            MPXL menambah anggaran capex dari rencana sebelumnya sebesar Rp 20
            miliar menjadi Rp 32 miliar.
          </p>
          <p>
            Capex MPXL dialokasikan untuk pembelian tanah dan renovasi pool
            kendaraan, serta uang muka pembelian 38 unit truk. Hingga semester
            pertama, anggaran capex sudah terserap sebanyak 55%.
          </p>
          <p>
            Sejalan dengan itu, MPXL juga sigap menyerap dana hasil penawaran
            umum. Dalam laporan per 30 Juni 2023 MPXL telah menggunakan dana
            sebesar Rp 35,28 miliar untuk modal kerja, pembelian lahan dan uang
            muka pembelian truk.
          </p>
          <p>
            Artinya, hanya dalam kurun waktu sekitar dua bulan, MPXL telah
            menyerap 90,04% dari hasil bersih dana IPO. Adapun, MPXL melepas 400
            juta saham baru atau setara 20% kepemilikan dalam aksi IPO.
          </p>
          <p>
            Dengan mematok harga penawaran Rp 108 per saham, MPXL meraih dana
            segar sebesar Rp 43,20 miliar. Setelah dikurangi biaya penawaran
            umum, hasil bersih yang dikantongi MPXL adalah Rp 39,18 miliar.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://investasi.kontan.co.id/news/ekspansi-mpx-logistics-mpxl-mengangkut-cuan-dari-material-konstruksi"
                target="_blank"
                rel="noreferrer"
              >
                https://investasi.kontan.co.id
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 7,
      title: "MPX Logistics (MPXL) Raih Kontrak Angkut FABA PLTU 660 Ribu Ton",
      url: "MPX-Logistics-(MPXL)-Raih-Kontrak-Angkut-FABA-PLTU-660-Ribu-Ton",
      image:
        "/images/artikel/MPX-Logistics-(MPXL)-Raih-Kontrak-Angkut-FABA-PLTU-660-Ribu-Ton.jpg",
      date: "Kamis, 20 Juli 2023 | 11:38 WIB",
      preview:
        "PT MPX Logistics International Tbk (MPXL) meraih kontrak pengangkutan Fly Ash dan Bottom Ash (FABA) PLTU sebanyak 660.000 ton dengan perusahaan semen raksasa asal China, PT CONCH Cement Indonesia.",
      desc: (
        <>
          <p>
            <strong>IDXChannel</strong> - PT MPX Logistics International Tbk
            (MPXL) meraih kontrak pengangkutan Fly Ash dan Bottom Ash (FABA)
            PLTU sebanyak 660.000 ton dengan perusahaan semen raksasa asal
            China, PT CONCH Cement Indonesia.
          </p>
          <p>
            Tambahan kontrak ini diperkirakan senilai Rp35 miliar. Dalam kontrak
            ini, emiten transportasi dan logistik tersebut akan mengangkut
            limbah batu bara PLTU ke lokasi Pabrik Semen untuk dimanfaatkan.
          </p>
          <p>
            Fly ash dan Bottom Ash merupakan abu yang dihasilkan dalam proses
            pembakaran batu bara di PLTU. Penggunaan FABA ini dalam industri
            semen dan infrastruktur semakin populer karena sifatnya yang ramah
            lingkungan dengan mengurangi polusi lingkungan.
          </p>
          <p>
            “Kontrak ini bukan hanya akan memberikan manfaat finansial bagi PT
            MPX Logistics International Tbk, tetapi juga akan meningkatkan citra
            perusahaan sebagai mitra yang handal dalam industri logistik. Dengan
            pengalaman dan kompetensi yang dimiliki, MPX Logistics dapat
            memastikan pengiriman yang tepat waktu dan profesional kepada
            perusahaan semen tersebut,” ucap Direktur Utama MPX Logistics
            International Wijaya Candera dalam keterangan resmi, Rabu
            (12/7/2023).
          </p>
          <p>
            MPXL pun optimistis kenaikan kinerja di semester 2-2023 ini akan
            melebihi target yang ditetapkan perseroan. Periode kontrak sendiri
            selama dua tahun dan akan berakhir pada bulan juli 2025.
          </p>
          <p>
            Sepanjang semester I-2023, pendapatan MPXL tercatat mengalami
            pertumbuhan Sebesar 24% secara tahunan atau year on year (yoy)
            menjadi Rp63,5 miliar dibanding semester I-2022 senilai Rp51,3
            miliar. Kenaikan pendapatan ditopang dari segmen penjualan material
            untuk proyek amman smelter sumbawa dan proyek pabrik kertas di
            kaltara.
          </p>
          <p>
            Dari sisi laba juga tercatat positif tumbuh 28% secara tahunan atau
            year on year (yoy) menjadi Rp4,35 miliar dibanding semester 1-2022
            senilai Rp3,39 miliar, aset perseroan meningkat 95 % menjadi 116,5
            miliar dari sebelum senilai Rp59,74 miliar dan ekuitas perseroan
            juga tercatat meningkat menjadi 86,3 miliar di laporan keuangan per
            30 juni 2023.
          </p>
          <p>
            "Pencapaian kinerja perseroan ini akan terus tumbuh seiring dengan
            mulai beroperasi 10 unit kendaraan truk tronton tangki baru di bulan
            juli ini. Perseroan juga menambah pesanan 5 unit truk baru jenis
            Trailer dan 10 unit dump truk tronton untuk memenuhi kebutuhan
            kontrak jasa angkut FABA PLTU ini," tambah Wijaya.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://www.idxchannel.com/market-news/mpx-logistics-mpxl-raih-kontrak-angkut-faba-pltu-660-ribu-ton"
                target="_blank"
                rel="noreferrer"
              >
                https://www.idxchannel.com
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 6,
      title:
        "MPXL Logistics Tandatangi MoU Kemitraan Strategis dengan Perusahaan TopFortune China",
      url: "MPXL-Logistics-Tandatangi-MoU-Kemitraan-Strategis-dengan-Perusahaan-TopFortune-China",
      image:
        "/images/artikel/MPXL-Logistics-Tandatangi-MoU-Kemitraan-Strategis-dengan-Perusahaan-TopFortune-China.jpg",
      date: "Senin, 05 Juni 2023 | 14:38 WIB",
      preview:
        "MPX Logistics Internasional (MPXL Tbk), sebuah perusahaan logistik berskala Internasional terkemuka, kemarin, Rabu (31/5) baru saja mengumumkan penandatanganan kontrak kemitraan strategis dengan PT. China West Development Indonesia untuk proyek-proyek di Indonesia. MoU ini juga mencakup pembelian material semen curah OPC sebanyak 100.000 ton lebih.",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID,</strong> MPX Logistics Internasional (MPXL
            Tbk), sebuah perusahaan logistik berskala Internasional terkemuka,
            kemarin, Rabu (31/5) baru saja mengumumkan penandatanganan kontrak
            kemitraan strategis dengan PT. China West Development Indonesia
            untuk proyek-proyek di Indonesia. MoU ini juga mencakup pembelian
            material semen curah OPC sebanyak 100.000 ton lebih.
          </p>
          <p>
            Sebagai anak perusahaan dari China State Construction Corporation
            (CSCEC), PT. China West Development Indonesia termasuk perusahaan
            konstruksi dengan reputasi mumpuni. Dari data yang kami ketahui,
            CSCEC ini adalah perusahaan public terbesar di Industri Beton China
            dan merupakan salah satu dari 500 perusahaan Top Fortune di China.
            tak hanya itu, perusahaan asal China ini juga perusahaan urutan 20
            teratas di industri bahan bangunan China.
          </p>
          <p>
            Penandatanganan dilakukan di Swissotel Jakarta PIK Avenue. Nota
            kesepemahaman ini menandai kesepakatan awal untuk kerjasama yang
            erat antara MPX Logistics Internasional dan PT. China West
            Development Indonesia. MPXL akan bertindak sebagai penyedia logistik
            dan transportasi untuk proyek konstruksi yang dilakukan oleh PT.
            China West Development Indonesia di Indonesia.
          </p>
          <p>
            "Kami sangat bangga dapat mengerjakan proyek bersama PT. China West
            Development Indonesia untuk mendukung kemajuan infrastruktur di
            Indonesia," kata Direktur Utama (Dirut) MPX Logistics Internasional
            Wijaya Candera.
          </p>
          <p>
            "Kemitraan ini akan menjamin pengiriman yang efisien, andal, dan
            terukur dari material konstruksi ke lokasi proyek." Sambungnya lagi.
          </p>
          <p>
            Proyek pertama yang akan digarap adalah Pembangunan Pulp Project di
            Tarakan atau di Sebut juga Phoenix Resources International Project ,
            Kalimantan Utara. MPXL akan mengatur pengiriman material senilai Rp
            130 Miliar selama 15 bulan, serta penyewaan alat berat.
          </p>
          <p>
            Kalimantan utara sendiri saat ini merupakan salah satu propinsi yang
            akan membangun Pembangkit Listrik Tenaga Air (PLTA) dan Kawasan
            Industri Hijau Indonesia (KIHI) . Ini akan meningkatkan investasi
            dari perusahaan nasional dan multinasional karena sumber Energi
            hijau yang murah dan ramah lingkungan.
          </p>
          <p>
            MPXL memiliki pengalaman dan pengetahuan yang luas dalam industri
            logistik yang meliputi jaringan transportasi, material proyek dan
            pergudangan. Penandatanganan MoU ini akan memungkinkan MPXL untuk
            menggunakan keahliannya dalam menyediakan ekspedisi dan pengaturan
            logistik yang tepat waktu dan efisien.
          </p>
          <p>
            “Adanya penandatanganan MoU ini adalah wujud kepercayaan dari mitra
            kami, dan juga dengan MOU ini MPXL secara resmi masuk juga di bisnis
            penyewaan alat berat sebagai divisi baru perusahaan kami. Saya
            berharap kerjasama ini dapat menjadi acuan bagi kami untuk selalu
            bersemangat menggali proyek-proyek baru dan akan selalu ikut andil
            dalam pembangunan infrastruktur di Indonesia.” jelasnya.
          </p>
          <p>
            MPXL terus berupaya untuk mengembangkan jaringan logistik yang kuat
            dan membantu perusahaan-perusahaan nasional dan internasional
            memenuhi kebutuhan logistik mereka. Melalui kemitraan strategis ini,
            MPXL akan memperkuat posisinya di industri logistik Indonesia dan
            dapat membantu meningkatkan kemajuan infrastruktur di Indonesia.
          </p>
          <p>
            Sebagai perusahaan logistik terkemuka, MPX Logistics memiliki visi
            untuk memberikan layanan yang unggul dan terpercaya bagi pelanggan
            di seluruh Indonesia. Dengan kemitraan strategis ini, MPXL akan
            menambah nilai terhadap proyek-proyek di Indonesia melalui
            pengiriman material yang tepat waktu dan efisien.
          </p>
          <p>
            Kontrak kemitraan strategis ini adalah langkah maju penting bagi
            MPXL dalam memperkuat posisinya sebagai penyedia logistik terkemuka
            yang mampu mengatasi tantangan logistik di Indonesia.
          </p>
          <p>
            <span
              style={{
                fontSize: ".9rem",
                fontStyle: "italic",
              }}
            >
              Sumber :{" "}
              <a
                href="https://amp.kontan.co.id/news/mpxl-logistics-tandatangi-mou-kemitraan-strategis-dengan-perusahaan-topfortune-china"
                target="_blank"
                rel="noreferrer"
              >
                https://www.kontan.co.id
              </a>
            </span>
          </p>
        </>
      ),
    },
    {
      id: 5,
      title:
        "PT MPX Logistics International Tbk (MPXL) Digandeng dalam Mega Project Amman Smelter",
      url: "PT-MPX-Logistics-International-Tbk-(MPXL)-Digandeng-dalam-Mega-Project-Amman-Smelter",
      image:
        "/images/artikel/PT-MPX-Logistics-International-Tbk-(MPXL)-Digandeng-dalam-Mega-Project-Amman-Smelter.jpg",
      date: "Senin, 5 Juni 2023 | 10:24 WIB",
      preview:
        "PT MPX Logistics International Tbk (MPXL), Salah satu perusahaan jasa transportasi infrastuktur dan perdagangan material yang baru saja go public ini di gandeng langsung oleh SINOHYDRO-NEM CONSORTIUM atau Anak Perusahaan Power China untuk bekerjasama dalam Pembangunan Mega Project Smelter Amman Mineral di Kabupaten Sumbawa Barat Propinsi Nusa Tenggara Barat.",
      desc: (
        <>
          <p>
            <strong>KONTAN.CO.ID</strong> - PT MPX Logistics International Tbk
            (MPXL), Salah satu perusahaan jasa transportasi infrastuktur dan
            perdagangan material yang baru saja go public ini di gandeng
            langsung oleh SINOHYDRO-NEM CONSORTIUM atau Anak Perusahaan Power
            China untuk bekerjasama dalam Pembangunan Mega Project Smelter Amman
            Mineral di Kabupaten Sumbawa Barat Propinsi Nusa Tenggara Barat.
          </p>
          <p>
            Pada Senin (15/05). PT MPX Logistics International Tbk (MPXL)
            menandatangani kontrak resmi dengan Sinohydro, dalam kerjasama ini
            PT MPX Logistics International Tbk (MPXL) mendapatkan kontrak jasa
            pengangkutan dan pemasok material terutama semen curah tipe OPC dan
            tipe V di project Smelter Aman Mineral Sumbawa, dengan kapasitas
            total 100,000 Ton.
          </p>
          <p>
            Perseroan sebelumnya sudah mendapatkan kontrak jasa penyewaan mobil
            Dumptruk dan saat ini sedang beroperasi di project Smelter Amman
            Mineral.
          </p>
          <p>
            “Kontrak yang sudah kami tanda tangani ini akan berlaku untuk 18
            bulan kedepan, di harapkan dengan adanya project di Sumbawa ini MPXL
            dapat bekerja sama dengan perusahaan yang ada di Indonesia Bagian
            Timur lain nya.” Ujar Direktur MPXL Susanto
          </p>
          <p>
            “MPXL tidak hanya menyediakan Jasa angkutan ataupun sebagai Pemasok
            material, tapi juga sebagai mitra transportasi pengangkut abu batu
            bara pembangkit listrik (PLTU) yang ada. MPXL berkomitmen akan
            selalu memberikan pelayanan jasa angkutan dan pasokan kebutuhan
            material yang berkualitas untuk mendukung project project pemerintah
            dan masyarakat dalam rangka membangun infrastruktur untuk Indonesia
            Maju 2045 .”Jelas Susanto Direktur PT MPX Logistics International
            Tbk (MPXL).
          </p>
          <span
            style={{
              fontSize: ".9rem",
              fontStyle: "italic",
            }}
          >
            Sumber :{" "}
            <a
              href="https://pressrelease.kontan.co.id/news/pt-mpx-logistics-international-tbk-mpxl-digandeng-dalam-mega-project-amman-smelter"
              target="_blank"
              rel="noreferrer"
            >
              https://pressrelease.kontan.co.id
            </a>
          </span>
        </>
      ),
    },
    {
      id: 4,
      title:
        "MPX Logistics International Tbk IPO Tawarkan Harga Rp103-Rp110 per Saham",
      url: "MPX-Logistics-International-IPO-Tawarkan-Harga-Rp103-Rp110-per-Saham",
      image:
        "/images/artikel/MPX-Logistics-International-IPO-Tawarkan-Harga-Rp103-Rp110-per-Saham.jpg",
      date: "Selasa, 11 April 2023 | 11:18 WIB",
      preview:
        "PT. MPX Logistics International Tbk (MPXL), salah satu perusahaan jasa transportasi pendukung infrastruktur dan pengangkut limbah batu bara Fly Ash dan Bottom Ash (FABA) berencana melakukan penawaran umum perdana (initial public offering/IPO) saham dengan melepas 400 juta saham baru atau sekitar 20% dari modal ditempatkan dan disetor penuh.",
      desc: (
        <>
          <p>
            <strong>
              JAKARTA, 11 April 2023 - PT. MPX Logistics International Tbk
              (MPXL)
            </strong>
            , salah satu perusahaan jasa transportasi pendukung infrastruktur
            dan pengangkut limbah batu bara Fly Ash dan Bottom Ash (FABA)
            berencana melakukan penawaran umum perdana (initial public
            offering/IPO) saham dengan melepas 400 juta saham baru atau sekitar
            20% dari modal ditempatkan dan disetor penuh.
          </p>
          <p>
            Adapun harga penawaran sekitar Rp103-Rp110 per lembar saham. Dengan
            demikian, dana yang akan diraup Perseroan berkisar Rp41,2 miliar
            sampai dengan Rp44 miliar.
          </p>
          <p>
            Bersamaan dengan Penawaran Umum tersebut, Perseroan juga akan
            menerbitkan Waran Seri I sebanyak-banyaknya 80 juta Waran Seri I
            atau setara dengan sebanyak-banyaknya 5% dari total jumlah saham
            ditempatkan dan disetor penuh. Waran Seri I akan diberikan secara
            cuma-cuma sebagai insentif bagi para pemegang Saham Baru.
          </p>
          <p>
            Pada setiap pemegang 5 Saham Baru Perseroan berhak memperoleh 1
            Waran Seri I di mana setiap 1 Waran Seri I dapat ditukar dengan 1
            saham biasa. Kisaran Harga Pelaksanaan sebesar Rp198-Rp368 setiap
            saham, yang dapat dilaksanakan setelah 6 bulan sejak Waran Seri I
            diterbitkan, yaitu mulai tanggal 09 November 2023 sampai dengan 08
            Mei 2024. Melalui penawaran ini Perseroan akan meraup dana sekitar
            Rp15,8 miliar sampai dengan Rp29,4 miliar.
          </p>
          <p>
            Adapun bertindak sebagai perusahaan penjamin pelaksana emisi efek
            yakni PT Panin Sekuritas Tbk (PANS).
          </p>
          <p>
            <strong>
              Direktur Utama PT. MPX Logistics International Tbk (MPXL) Wijaya
              Candera
            </strong>{" "}
            mengatakan hasil dana dari aksi korporasi ini setelah dikurangi
            biaya-biaya emisi efek, sekitar 12,7% untuk pembayaran uang muka
            untuk pembelian armada truk, Perseroan telah melakukan pemesanan
            sebanyak 10 unit kendaraan dengan harga setiap kendaraan dan
            karoseri Tanki sekitar Rp1,3 miliar untuk meningkatkan pendapatan
            perseroan. Kemudian, sebesar 36,9% untuk pembelian tanah dan
            bangunan di Propinsi Banten guna mendukung dan memperlancar
            aktivitas perseroan.
          </p>
          <p>
            Sisanya, sekitar 50,2% dana yang diperoleh akan digunakan oleh
            Perseroan untuk Modal Kerja, yaitu untuk pembelian material, biaya
            operasional, pemeliharaan kendaraan, pengurusan perizinan kendaraan,
            biaya kantor lainnya, pelunasan utang dagang, dan pelunasan akrual.
          </p>
          <p>
            “Sementara dari pelaksanaan Waran Seri I yang kami tawarkan guna
            menarik minat investor, akan digunakan seluruhnya untuk Modal Kerja,
            yaitu untuk pembelian material, biaya operasional, pemeliharaan
            kendaraan, pengurusan perizinan kendaraan, biaya kantor lainnya, dan
            pelunasan utang dagang,” paparan melalui siaran pers, Selasa
            (11/4/2023)
          </p>
          <p>
            Wijaya mengatakan saat ini perseroan selain melakukan aktivitas jasa
            angkutan pendukung infrastruktur , Perseroan juga melakukan
            aktivitas perdagangan material khususnya semen curah dan FABA.
          </p>
          <p>
            Menurut Wijaya prospek kinerja Perseroan ke depan akan sangat baik,
            dengan salah satu indikasi kinerja industri semen yang stabil pada
            tahun lalu ditambah tren perbaikan konsumsi semen terjadisejak tahun
            sebelumnya atau pada 2021 yang bertumbuh sebesar 4,3% setelah pada
            2020 yang mengalami kontraksi pertumbuhan sebesar 10,7% secara
            tahunan.
          </p>
          <p>
            “Diharapkan baik tren konsumsi maupun kapasitas produksi akan terus
            membaik seiring dengan fokus Pemerintah untuk melakukan pembangunan
            Ibu Kota Baru (IKN) di Kalimantan Timur, dengan adanya pembangunan
            IKN hal ini akan menjadi domino efek untuk pembangunan infrastruktur
            hingga fasilitas penunjang ditambah pembangunan properti pendukung
            seperti gedung perkantoran dan perumahan, otomatis hal ini akan
            mendongkrak konsumsi semen nasional dan berdampak pada bisnis
            Perseroan,” ujarnya.
          </p>
          <p>
            Selain itu, sejumlah strategi pertumbuhan akan terus digencarkan
            Perseroan salah satunya dengan menawarkan kerja sama dengan
            perusahaan-perusahaan yang menghasilkan produk yang dibutuhkan
            pelanggan Perseroan, seperti pabrik semen, PLTU dan sektor
            pertambangan.
          </p>
          <p>
            Tak hanya itu, Perseroan akan mencari pelanggan yang membutuhkan
            produk-produk semen, FABA, dan produk pertambangan seperti pabrik
            semen, pabrik bata ringan, batching plant, distributor dan
            kontraktor untuk proyek infrastruktur.
          </p>
          <p>
            Sisi lain Perseroan akan terus membina hubungan baik dengan pemasok
            maupun pelanggan dengan memberikan pelayanan yang terbaik. Terakhir
            tentunya Perseroan akan menjaga manajemen waktu yang akurat dalam
            memenuhi ekspektasi pelanggan eksisting juga dalam menjangkau lebih
            banyak pelanggan baru.
          </p>
          <p>
            “Adapun menambah jumlah armada baru dari hasil dari Penawaran Umum
            ini agar dapat menambah volume pengangkutan dan penjualan material.
            Dengan jumlah armada yang memadai, Perseroan dapat meningkatkan
            kecepatan dan ketepatan waktu pengiriman kepada pelanggan,” katanya.
          </p>
          <p>
            Rencananya, pencatatan saham dan Waran Seri I akan dilakukan pada 9
            Mei 2023. Masa penawaran dilakukan pada 11-14 April 2023.
            Selanjutnya masa penawaran umum perdana saham akan dilakukan pada
            3-5 Mei 2023, dan distribusi secara elektronik akan dilakukan pada 8
            Mei 2023.
          </p>
        </>
      ),
    },
    {
      id: 3,
      title:
        "MPX Logistics International Tbk berhasil raih 2 sertifikasi internasional",
      url: "MPX-Logistics-International-berhasil-raih-2-sertifikasi-internasional",
      image:
        "/images/artikel/MPX-Logistics-International-berhasil-raih-2-sertifikasi-internasional.jpeg",
      date: "Selasa, 01 November 2022 | 14:03 WIB",
      preview:
        "Implementasi sistem manajemen Mutu serta sistem manajemen Kesehatan dan Keselamatan Kerja(SMK3) merupakan syarat mutlak bagi keberlangsungan aktivitas operasional pada bidang logistik",
      desc: (
        <>
          <p>
            Implementasi sistem manajemen Mutu serta sistem manajemen Kesehatan
            dan Keselamatan Kerja(SMK3) merupakan syarat mutlak bagi
            keberlangsungan aktivitas operasional pada bidang logistik. Selain
            menjadi penyokong dalam komitmen memberikan pelayanan terbaik kepada
            pelanggan juga memberikan perlindungan dan lingkunan kerja yang aman
            bagi setiap pekerja yang terlibat didalamnya.
          </p>
          <p>
            PT. MPX Logistics International Tbk, telah berhasil mendapatkan
            sertifikasi sistem manajemen Mutu ISO 9001:2015 dan sistem manajemen
            Kesehatan dan Keselamatan Kerja ISO 45001:2018 pada tanggal 25 Mei
            2022.
          </p>
          <p>
            Wijaya Candera, selaku Direktur Utama PT. MPX Logistics
            International Tbk mengatakan, pencapaian sertifikasi berstandar
            internasional ini merupakan salah satu perwujudan dari visi
            perusahaan untuk menjadi perusahaan logistik di Indonesia yang
            memiliki kelas dan standar pelayanan internasional.
          </p>
          <p>
            ISO 9001:2015 merupakan standar internasional sistem manajemen mutu,
            yang bertujuan menjamin produk atau jasa yang diberikan oleh
            perusahaan memenuhi persyaratan yang telah ditetapkan oleh badan
            standar dunia (ISO). Ketika perusahaan dinyatakan lulus setelah
            melalui proses yang panjang dan melalui tahap akhir audit, artinya
            perusahaan telah memenuhi persyaratan yang telah ditetapkan secara
            internasional dalam tanggung jawab memberikan jaminan kualitas
            terhadap produk atau jasa yang diberikan.
          </p>
          <p>
            Sedangkan ISO 45001:2018 merupakan standar internasional pada sistem
            manajemen Kesehatan dan Keselamatan Kerja (SMK3) untuk meminimalisir
            resiko kecelakaan kerja, juga menciptakan tempat kerja yang aman dan
            sehat untuk setiap pekerja, mitra, pengunjung, juga pelanggan.
          </p>
          <p>
            Sertifikasi ISO juga secara rutin meninjau sistem yang telah
            diterapkan pada perusahaan, juga tanggung jawab dari para pimpinan
            perusahaan serta partisipasi pekerja dalam menjaga standar mutu dan
            K3 yang telah ditetapkan dan apakah secara konsisten melakukan
            identifikasi resiko, menilai konsekuensi dan juga menentukan metode
            pengendalian yang tepat dan efektif.
          </p>
          <p>
            Tidak berhenti disini, kedepan PT. MPX Logistics International Tbk
            akan terus melakukan improvisasi berkelanjutan pada sistem manajemen
            di perusahaan untuk menunjang tercapainya visi dan misi perusahaan.
          </p>
        </>
      ),
    },
    {
      id: 2,
      title:
        "Dukung Ekspansi Perusahaan MPX International Jajaki Pendanaan dari Pasar Modal",
      url: "Dukung-Ekspansi-Perusahaan-MPX-International-Jajaki-Pendanaan-dari-Pasar-Modal",
      image:
        "/images/artikel/Dukung-Ekspansi-Perusahaan-MPX-International-Jajaki-Pendanaan-dari-Pasar-Modal.jpg",
      date: "Minggu, 31 Oktober 2021 | 22:57 WIB",
      preview:
        "MPX Logistics International Tbk sebagai perusahaan yang bergerak di bidang jasa transportasi dan logistik, optimistis perekonomian Indonesia akan semakin membaik.",
      desc: (
        <>
          <p>
            <strong>Jakarta, Beritasatu.com</strong> - MPX Logistics
            International sebagai perusahaan yang bergerak di bidang jasa
            transportasi dan logistik, optimistis perekonomian Indonesia akan
            semakin membaik. Direktur Utama MPX Logistics International Tbk,
            Wijaya Candera mengatakan konsep bisnis MPX Logistics International
            Tbk saat ini, adalah business to business (B2B) dan business to
            customer (B2C) yang memiliki komitmen untuk menjaga kepercayaan
            semua relasi bisnis dan masyarakat, agar tercipta kerja sama jangka
            panjang yang baik.
          </p>
          <p>
            "Kami hadir sejak tahun 2008, dimana para klien tetap kami merupakan
            perusahaan yang berskala nasional dan internasional, seperti Astra
            International, Wings Group, PT Sinar Sosro, Shell Helix, Semen
            Indonesia Group, Indocement, Conch Semen, Sinohydro dan masih banyak
            lainnya,” ungkap Wijaya, dalam keterangannya kepada Beritasatu.com,
            Minggu (31/10/2021).
          </p>
          <p>
            Berangkat dari kerja sama yang terjalin, lanjut Wijaya, MPX
            optimistis di tahun 2022 bisa meraih pertumbuhan yang lebih baik.
            Terlebih lagi peluang bisnis di bidang transportasi dan logistik
            saat ini sudah mulai bangkit. "Walaupun di tahun lalu, di Indonesia
            ataupun internasional ekonomi sempat jatuh karena adanya pandemi
            covid-19, akan tetapi distribusi vaksin yang terus merata secara
            global, membuat kita optimistis pandemi ini akan berlalu,” jelas
            Wijaya.
          </p>
          <p>
            Menurut dia, strategi bisnis yang tepat menjadi kunci dalam
            menghadapi pasar. Strategi bisnis yang akan diterapkan MPX Logistic
            International salah satunya, mengusung konsep go digital, dimana
            segala hal akan menjadi lebih mudah dan cepat apabila dikerjakan
            secara digital memasuki era revolusi industri 4.0.
          </p>
          <p>
            Wijaya mengatakan, konsep go digital ini akan diluncurkan melalui
            aplikasi MPXGO, sehingga masyarakat mudah dalam mengakses informasi
            mengenai biaya transportasi dan logistik yang diharapkan. "Dengan
            memperluas area service transportasi dan logistik ke seluruh wilayah
            Indonesia, bahkan ke kancah internasional, menjadi bekal kami untuk
            mendukung program pemerintah di era digitalisasi ke depan,” jelas
            Wijaya.
          </p>
          <p>
            Strategi lainnya, perusahaan akan mencari pendanaan dari pasar modal
            untuk mendukung ekspansi perusahaan. Dengan demikian, tata kelola
            perusahaan menjadi lebih baik, dan dapat menciptakan lebih banyak
            lapangan kerja untuk masyarakat.
          </p>
        </>
      ),
    },
    {
      id: 1,
      title: "MPX Logistics Rutin Melakukan Pelatihan Karyawan",
      url: "MPX-Logistics-Rutin-Melakukan-Pelatihan-Karyawan",
      image:
        "/images/artikel/MPX-Logistics-Rutin-Melakukan-Pelatihan-Karyawan.jpg",
      date: "Minggu, 31 Oktober 2021 | 23:12 WIB",
      preview:
        "Menurut kami Pelatihan Kerja atau Pelatihan Karyawan adalah hal yang penting dan wajib di lakukan Bagi setiap Karyawan dan Perusahaan.",
      desc: (
        <>
          <p>
            Menurut kami Pelatihan Kerja atau Pelatihan Karyawan adalah hal yang
            penting dan wajib di lakukan Bagi setiap Karyawan dan Perusahaan.
            Pelatihan kerja berdasarkan UU No. 13 Tahun 2003 tentang
            Ketenagakerjaan adalah keseluruhan kegiatan untuk memberi,
            memperoleh, meningkatkan, serta mengembangkan kompetensi kerja,
            produktivitas, disiplin, sikap, dan etos kerja pada tingkat
            keterampilan dan keahlian tertentu sesuai dengan jenjang dan
            kualifikasi jabatan atau pekerjaan.
          </p>
          <p>
            Dengan melakukan training, para karyawan dapat memiliki pengetahuan,
            kemampuan, dan keterampilan sesuai dengan pekerjaan yang mereka
            lakukan. Perusahaan selalu membutuhkan tenaga-tenaga yang
            berkompeten di bidangnya untuk meningkatkan perkembangan perusahaan.
            Oleh karena itu, MPX Logistics International Tbk melakukan pelatihan
            dan pembinaan karyawan secara rutin.
          </p>
          <p>
            <h3>
              <strong>Tujuan Training Atau Tujuan Pelatihan Karyawan</strong>
            </h3>
            <p>
              <strong>1. Ilmu Pengetahuan (Knowledge)</strong>
              <br />
              Para karyawan MPX Logistics International Tbk yang dilatih atau
              dibina oleh perusahaan diharapkan mendapatkan ilmu pengetahuan
              yang cukup untuk dapat mengerjakan tugas yang akan diberikan.
            </p>
            <p>
              <strong>2. Kemampuan (Skill)</strong>
              <br />
              Para karyawan yang baru MPX Logistics International Tbk dilatih
              diharapkan dapat dan mampu melakukan tugas saat ditempatkan pada
              proses yang telah ditentukan.
            </p>
            <p>
              <strong>3. Penentuan Sikap (Attitude)</strong>
              <br />
              Setelah melakukan pelatihan kerja, karyawan baru MPX Logistics
              International diharapkan dapat memiliki minat dan kesadaran atas
              pekerjaan yang akan dilakukannya.
            </p>
          </p>
          <p>
            Tujuan yang ingin dicapai dari program training karyawan tersebut
            pada dasarnya untuk mendukung kelancaran operasional dan
            produktivitas perusahaan.
          </p>
          <p>
            <h3>
              <strong>Manfaat Pelatihan Dan Training Kerja</strong>
            </h3>
            <p>
              Pelatihan kerja yang baik akan membawa manfaat bagi karyawan dan
              perusahaan. Bagi MPX Logistics International Tbk Banyak sekali
              manfaat yang diperoleh dari hasil training karyawan. Berikut ini
              merupakan ringkasan manfaat training yang telah kami lakukan,
              antara lain:
              <br />
              <ol>
                <li>Memiliki tenaga kerja yang ahli dan terampil.</li>
                <li>Meningkatkan produktivitas kerja.</li>
                <li>Meningkatkan mutu hasil kerja.</li>
                <li>
                  Tugas dan pekerjaan dapat berjalan lancar kapan pun dan di
                  mana pun.
                </li>
                <li>Meningkatkan rasa percaya diri karyawan kami.</li>
                <li>Mengurangi waktu yang digunakan untuk belajar.</li>
                <li>
                  Memahami pekerjaan dan budaya kerja di MPX Logistics
                  International.
                </li>
                <li>
                  Menambah pengetahuan dan keterampilan di bidangnya
                  masing-masing karyawan kami.
                </li>
              </ol>
            </p>
          </p>
        </>
      ),
    },
  ],
};

export default articles;
